import React from 'react'
import { useState } from 'react';
import AdminNavbar from "../Navbars/AdminNavbar";
import Sidebar from "../Sidebar/Sidebar";
import { SuperAdminApis } from '../../apis/superAdminApi';
import { useNavigate } from 'react-router-dom';
import { AxiosResponse } from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSelector, useDispatch } from 'react-redux';
import { BsCheckSquare, BsSquare } from "react-icons/bs";

import { convertUTCDateToLocalDate, getDeadlineStatus } from '../Reusable/functions';
//@ts-ignore
import Modal from 'react-awesome-modal';
import { SvgElement, icontypesEnum } from '../assets/svgElement';
import { AuthApis } from '../../apis/authApis';
import { error } from 'console';
import AdminSidebar from '../Sidebar/AdminSidebar';
import { STATUSTYPES } from '../Reusable/Status';
import { Oval } from 'react-loader-spinner';
import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import { PDFDownloadLink } from '@react-pdf/renderer';
import { MdDownload } from "react-icons/md";
import * as XLSX from 'xlsx';
import Select from 'react-select';

interface ShipmentData {
  created_at: string;
  fleet_name: string;
  manifest_id: string;
  destination_state: string;
  manifest_name: string;
  shipments: any[];
}

interface ShipmentExport {
  shipmentNumber: string;
  senderName: string;
  receiverName: string;
  senderAdd1: string;
  receiverAdd1: string;
  weight: number;
  goodsDescription: string;
  status: string;
  deliveryInstructions: string;
  freightCost: number;
  shipments: any[];
}

const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 10,
  },
  section: {
    marginBottom: 10,
  },
  header: {
    fontSize: 14,
    marginBottom: 10,
    textAlign: 'center',
    textTransform: 'uppercase',
    fontWeight: 'bold',
  },
  table: {
    display: 'flex',
    paddingTop: 40,
    flexDirection: 'column',
    width: '100%',
  },
  tableRow: {
    display: 'flex',
    flexDirection: 'row',
    borderBottom: '1px solid #000',
    paddingBottom: 4,
    marginBottom: 4,
  },
  tableCol: {
    flex: 1,
    padding: 4,
  },
  tableColl: {
    flex: 3,
    fontSize: 10,
    padding: 4,
    fontWeight: 'bold',
  },
  tableColHeader: {
    flex: 1,
    padding: 4,
    fontWeight: 'bold',
  },
  boldText: {
    fontWeight: 'bold',
  },
  footer: {
    marginTop: 10,
    paddingTop: '50px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  footer2: {
    marginTop: 20,
    paddingTop: '10px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  footerText: {
    fontSize: 10
  },
  logo: {
    width: 100,
    height: 'auto',
    marginBottom: 20,
  }
});

const exportManifestData = (manifestData: any) => {
  const exportData = manifestData.flatMap((manifest: any) => {
    return manifest.shipments.map((shipment: any, index: any) => ({
      manifestId: manifest.manifest_id,
      manifestName: manifest.manifest_name,
      createdBy: manifest.created_by,
      eventLocation: manifest.event_location,
      branch: manifest.branch,
      shipmentStatus: manifest.shipment_status,
      fleetName: manifest.fleet_name,
      vehicleName: manifest.vehicle_name,
      created_at: manifest.created_at,
      updated_at: manifest.updated_at,
      riderName: manifest.rider_name,
      shipmentNumber: shipment.ShipmentNumber,
      senderName: shipment.SenderName,
      receiverName: shipment.ReceiverName,
      senderAdd1: shipment.SenderAdd1,
      'Reciever Address': shipment.ReceiverAdd1,
      weight: shipment.Weight,
      goodsDescription: shipment.GoodsDescription,
      status: shipment.Status,
      deliveryInstructions: shipment.DeliveryInstructions,
      freightCost: shipment.FreightCost,
    }));
  });

  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(exportData);
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Manifests');
  XLSX.writeFile(workbook, 'runway_manifest.xlsx');
};

const exportShipmentsToExcel = (manifestInfo: any, shipmentsData: any[]) => {
  if (!shipmentsData || shipmentsData.length === 0) {
    toast.error('No shipments to export');
    return;
  }

  const exportData = shipmentsData.map((shipment: any, index: number) => ({
    'S/N': index + 1,
    'Status Badge': shipment.history_status === 'active' ? 'Active' : 'Moved',
    'Manifest Name': manifestInfo?.manifest?.manifest_name || manifestInfo?.manifest_name || 'N/A',
    'Manifest ID': manifestInfo?.manifest?.manifest_id || manifestInfo?.manifest_id || 'N/A',
    'Receiver Name': shipment?.ReceiverName || shipment?.receiver_name || 'N/A',
    'Receiver Phone': shipment?.ReceiverPhone || shipment?.receiver_phone || 'N/A',
    'Receiver Address': shipment?.ReceiverAdd1 || shipment?.receiver_address || 'N/A',
    'Receiver City': shipment?.ReceiverAddCity || 'N/A',
    'Receiver State': shipment?.ReceiverAddState || 'N/A',
    'Status': shipment?.Status || shipment?.status || 'Unknown',
    'Shipment Number': shipment?.ShipmentNumber || shipment?.shipment_number || 'Not Available',
    'Weight (kg)': shipment?.Weight || shipment?.weight || '0',
    'Number of Items': shipment?.NoOfItems || shipment?.number_of_items || '0',
    'Sender Name': shipment?.SenderName || 'N/A',
    'Sender Phone': shipment?.SenderPhone || 'N/A',
    'Sender Address': shipment?.SenderAdd1 || 'N/A',
    'Goods Description': shipment?.GoodsDescription || 'N/A',
    'Fleet Name': manifestInfo?.manifest?.fleet_name || manifestInfo?.fleet_name || 'N/A',
    'Moved To Manifest': shipment.history_status === 'moved' ? shipment.moved_to_manifest_name || 'N/A' : 'Currently Active',
    'Moved To Manifest ID': shipment.history_status === 'moved' ? shipment.moved_to_manifest_id || 'N/A' : '-',
    'Moved At': shipment.moved_at ? new Date(shipment.moved_at).toLocaleString() : '-',
    'Export Date': new Date().toLocaleString(),
  }));

  const workbook = XLSX?.utils?.book_new();
  const worksheet = XLSX.utils?.json_to_sheet(exportData);

  const colWidths = [
    { wch: 5 },
    { wch: 10 },
    { wch: 20 },
    { wch: 15 },
    { wch: 20 },
    { wch: 15 },
    { wch: 30 },
    { wch: 15 },
    { wch: 15 },
    { wch: 15 },
    { wch: 15 },
    { wch: 10 },
    { wch: 10 },
    { wch: 20 },
    { wch: 15 },
    { wch: 30 },
    { wch: 25 },
    { wch: 15 },
    { wch: 25 },
    { wch: 20 },
    { wch: 20 },
    { wch: 20 },
  ];
  worksheet['!cols'] = colWidths;

  XLSX?.utils?.book_append_sheet(workbook, worksheet, 'Shipments');

  const fileName = `runway_shipments_${manifestInfo?.manifest?.manifest_id || manifestInfo?.manifest_id || 'manifest'}_${new Date().toISOString().split('T')[0]}.xlsx`;
  XLSX?.writeFile(workbook, fileName);

  toast.success(`Exported ${exportData.length} shipments successfully!`);
};

const ShipmentManifest = ({ data }: { data: ShipmentData }) => (
  <Document>
    <Page style={styles.page}>
      <View>
        <Image
          style={styles.logo}
          src="/images/Auth/logo.png"
        />
      </View>
      <Text style={styles.header}>Runway Manifest</Text>

      <View style={styles.section}>
        <Text style={{ paddingBottom: 8 }}><Text style={{ fontWeight: 'bold' }}>Date</Text> : {convertUTCDateToLocalDate(data.created_at)}</Text>
        <Text style={{ paddingBottom: 8 }}><Text style={{ fontWeight: 'bold' }}>Fleet</Text> : {data.fleet_name}</Text>
        <Text style={{ paddingBottom: 8 }}> <Text style={{ fontWeight: 'bold' }}>Manifest Name</Text> : {data.manifest_name}</Text>
        <Text style={{ paddingBottom: 8 }}> <Text style={{ fontWeight: 'bold' }}>Manifest Id</Text> : {data.manifest_id}</Text>
      </View>

      <View style={styles.table}>
        <View style={styles.tableRow}>
          <View style={styles.tableColHeader}>
            <Text>Shipment Id #</Text>
          </View>
          <View style={styles.tableCol}>
            <Text>Shipper</Text>
          </View>
          <View style={styles.tableColl}>
            <Text>Receiver</Text>
          </View>
          <View style={styles.tableCol}>
            <Text>Weight</Text>
          </View>
          <View style={styles.tableCol}>
            <Text>Notes</Text>
          </View>
        </View>
        {(data.shipments && Array.isArray(data.shipments)) ? data.shipments.map((shipment, index) => (
          <View key={index} style={styles.tableRow}>
            <View style={styles.tableColHeader}>
              <Text style={styles.boldText}>{shipment.ShipmentNumber}</Text>
            </View>
            <View style={styles.tableCol}>
              <Text>{shipment.SenderName},{shipment.SenderAddState},{shipment.SenderCountryCode} </Text>
            </View>
            <View style={styles.tableColl}>
              <Text>{shipment.ReceiverName},{shipment.ReceiverAdd1},{shipment.ReceiverAddState},{shipment.ReceiverCountryCode},{shipment.ReceiverPhone} </Text>
            </View>
            <View style={styles.tableCol}>
              <Text>{shipment.Weight} {shipment.WeightMeasurement} / {shipment.NoOfItems} Pcs </Text>
            </View>
            <View style={styles.tableCol}>
            </View>
          </View>
        )) : (
          <View style={styles.tableRow}>
            <View style={styles.tableCol}>
              <Text>No shipments available</Text>
            </View>
          </View>
        )}
      </View>

      <View style={styles.footer2}>
        <Text style={styles.footerText}>Total Shipments: {data.shipments?.length || 0} </Text><br />
      </View>

      <View style={styles.footer}>
        <Text style={styles.footerText}>Driver's Signature: ______________________</Text>
        <Text style={styles.footerText}>Collected date/time: ______________________</Text>
      </View>
    </Page>
  </Document>
);

function RunwayManifest() {
  const deliveryStatuses = [
    "Out for Delivery",
    "Proof of Delivery",
    "In Transit to Destination",
    "Delivered",
    "Delayed Linehaul Departure",
    "Attempted Delivery - Inaccurate / Incomplete Address",
    "Not Delivered - Bad Weather Conditions",
    "Attempted Delivery - No One Available/Home",
    "Due to Unforeseen Circumstances Delivery is Rescheduled for Next Working Day",
    "Attempted Delivery - Consignee Refused Shipment",
    "Attempted Delivery - Unable to Locate Consignee",
    "Attempted Delivery - Consignee Moved",
    "On Hold - Awaiting Pickup by Consignee",
    "Delivery Delays - Please Contact Customer Services",
    "Attempted Delivery - Unable to Deliver - Please Contact Customer Services",
    "Not Delivered - Consignee Scheduled Delivery",
    "Attempted Delivery - Unable to Access Premises",
    "Attempt to Contact Consignee Failed",
    "On Hold - Requires Correct Telephone Number",
    "On Hold - Delivery Needs To Be (Re)Scheduled For/With Consignee",
    "Attempted Delivery - Business Closed",
    "Attempted Delivery - No One Available/Home",
    "Not Delivered - Traffic Accident",
    "Incorrect Driver Assignment",
    "In Transit - Delayed Linehaul",
    "Attempted Delivery - Closed / Holiday",
    "Not Delivered - Rescheduled by Customer",
    "Not Delivered - Rescheduled Delivery",
    "Not Delivered - Partial Delivery",
    "On Hold - Inaccurate / Incomplete Address",
    "Attempted Delivery - No Safe Place to Leave",
    "Not Delivered - Held Awaiting Instructions",
    "Shipment Returned to Sender",
    "Returned to Sender - Duties/Taxes not paid by receiver",
    "Returned to Sender - Delivery attempts exceeded",
    "Delivery to Temu local warehouse (Buffalo)",
  ];

  const [eventDateTime, setEventDateTime] = React.useState<string>(() => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  });

  const statusOptions = STATUSTYPES?.map((datas: any) => ({
    value: datas?.EventName,
    label: datas?.EventName,
  }));

  const [canBypassCode, setCanBypassCode] = React.useState<boolean>(false);
  const userLoginData = useSelector((state: any) => state.data.login.value);
  const [permissions, setPermissions] = React.useState<any>(userLoginData?.data?.permissions ? JSON.parse(userLoginData?.data?.permissions) : ['']);

  React.useEffect(() => {
    permissions?.map((data: any, index: any) => {
      if (data === 'can_bypass_delivery_code' || userLoginData?.data?.role == 'admin') {
        setCanBypassCode(true);
      }
    })
  }, []);

  const navigate = useNavigate();
  const [userLists, setUserList] = React.useState<any>([]);
  const [stateFrom, setStateFrom] = React.useState<any>([]);
  const [statusModal, setStatusModal] = React.useState<boolean>(false);
  const [percentage, setPercentage] = React.useState<number>(0);
  const [rejectedNo, setRejectedNo] = React.useState<string>('');

  const handleShipmentExport = () => {
    if (!manifestData || !manifestData.shipments || manifestData.shipments.length === 0) {
      toast.error('No shipments available to export');
      return;
    }

    setLoading(true);
    try {
      exportShipmentsToExcel(manifestData, manifestData.shipments);
    } catch (error) {
      toast.error('Export failed');
      console.error('Export error:', error);
    } finally {
      setLoading(false);
    }
  };

  function toggleStatus() {
    setStatusModal(true)
  }

  const [shipmentId, setShipmentId] = React.useState<any>([]);
  const [shipmentStatus, setShipmentStatus] = React.useState<string>('');
  const [verOption, setVerOption] = React.useState<string>('');
  const [manifestData, setManifestData] = React.useState<any>([]);
  const [nextPageId, setNextPageId] = React.useState<any>([]);

  const [shipmentSearchText, setShipmentSearchText] = React.useState<string>('');
  const [activeStatusFilter, setActiveStatusFilter] = React.useState<string | null>(null);


  const filteredShipments = React.useMemo(() => {
    if (!manifestData?.shipments) return [];

    let filtered = [...manifestData.shipments];

    // Only show active shipments by default, unless specifically filtering
    // You can remove this if you want to show all by default
    // filtered = filtered.filter((s: any) => s.history_status === 'active');

    // Filter by active status filter
    if (activeStatusFilter) {
      filtered = filtered.filter((shipment: any) => {
        const status = shipment?.Status || shipment?.status || 'Unknown';
        return status.toLowerCase() === activeStatusFilter.toLowerCase();
      });
    }

    // Filter by search text
    if (shipmentSearchText.trim()) {
      const searchLower = shipmentSearchText.toLowerCase().trim();
      filtered = filtered.filter((shipment: any) => {
        const receiverName = (shipment?.ReceiverName || '').toLowerCase();
        const receiverPhone = (shipment?.ReceiverPhone || '').toLowerCase();
        const receiverAddress = (shipment?.ReceiverAdd1 || '').toLowerCase();
        const shipmentNumber = (shipment?.ShipmentNumber || '').toLowerCase();
        const status = (shipment?.Status || shipment?.status || '').toLowerCase();
        const senderName = (shipment?.SenderName || '').toLowerCase();

        return (
          receiverName.includes(searchLower) ||
          receiverPhone.includes(searchLower) ||
          receiverAddress.includes(searchLower) ||
          shipmentNumber.includes(searchLower) ||
          status.includes(searchLower) ||
          senderName.includes(searchLower)
        );
      });
    }

    return filtered;
  }, [manifestData?.shipments, shipmentSearchText, activeStatusFilter]);


  const [searchText, setSearchText] = React.useState('');
  const [selectType, setSelectType] = React.useState('today');
  const [searchText2, setSearchText2] = React.useState('');

  const [riderModal, setRiderModal] = React.useState<boolean>(false);
  const [shipmentRider, setShipmentRider] = React.useState<any>('');
  const [riders, setRiders] = React.useState<any>([]);
  const [fleet, setFleet] = React.useState<any>([]);
  const [vehicle, setVehicle] = React.useState<any>([]);
  const [shipmentInfo, setShipmentInfo] = React.useState<any>([]);
  const [runmanifestListData, setrunmanifestListData] = React.useState<any>([]);
  const [shipmentStatusId, setShipmentStatusId] = React.useState<string>('');
  const [delieveryInstruction, setDelieveryInstruction] = React.useState<string>('');
  const [delieveryCode, setDelieveryCode] = React.useState<string>('');

  const [dateFrom, setDateFrom] = React.useState('');
  const [dateTo, setDateTo] = React.useState('');

  const [barcodeValues, setBarcodeValues] = React.useState<string[]>([]);
  const [currentInput, setCurrentInput] = React.useState<string>("");

  const [showShipment, setShowShipment] = React.useState<boolean>(false);

  const [shipid, setShipId] = React.useState<any>({
    shipids: [],
  });

  const [addModal, setAddModal] = React.useState<boolean>(false);
  const [tabNo, setTabNo] = React.useState<string>('1');
  const [fleetData, setFleetData] = React.useState<any>([]);
  const [fleetData2, setFleetData2] = React.useState<any>([]);

  const handleChange2 = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFleetData2({ ...fleetData2, [name]: value });
  };

  const [scannerStats, setScannerStats] = useState({
    total: 0,
    valid: 0,
    invalid: 0,
    duplicates: 0
  });

  const [validationResults, setValidationResults] = useState<{ [key: string]: 'valid' | 'invalid' | 'duplicate' }>({});
  const [isValidating, setIsValidating] = useState(false);
  const [validationTimeout, setValidationTimeout] = useState<NodeJS.Timeout | null>(null);

  const validateShipmentNumbers = React.useCallback(async (barcodes: string[]) => {
    if (barcodes.length === 0) {
      setScannerStats({ total: 0, valid: 0, invalid: 0, duplicates: 0 });
      setValidationResults({});
      return;
    }

    setIsValidating(true);

    try {
      const duplicateCheck: { [key: string]: number } = {};
      const newValidationResults: { [key: string]: 'valid' | 'invalid' | 'duplicate' } = {};

      barcodes.forEach(barcode => {
        if (barcode.trim()) {
          duplicateCheck[barcode] = (duplicateCheck[barcode] || 0) + 1;
        }
      });

      Object.keys(duplicateCheck).forEach(barcode => {
        if (duplicateCheck[barcode] > 1) {
          newValidationResults[barcode] = 'duplicate';
        }
      });

      const uniqueBarcodes = barcodes.filter((barcode, index, arr) =>
        arr.indexOf(barcode) === index && barcode.trim() !== ''
      );

      if (uniqueBarcodes.length > 0) {
        const response = await SuperAdminApis.validateShipmentNumbers(uniqueBarcodes);

        if (response?.data?.status) {
          const validShipments = response.data?.data?.validShipments || [];
          const invalidShipments = response.data.data.invalidShipments || [];

          validShipments.forEach((shipment: string) => {
            if (newValidationResults[shipment] !== 'duplicate') {
              newValidationResults[shipment] = 'valid';
            }
          });

          invalidShipments.forEach((shipment: string) => {
            if (newValidationResults[shipment] !== 'duplicate') {
              newValidationResults[shipment] = 'invalid';
            }
          });
        }
      }

      const stats = {
        total: barcodes.filter(b => b.trim()).length,
        valid: Object.values(newValidationResults).filter(status => status === 'valid').length,
        invalid: Object.values(newValidationResults).filter(status => status === 'invalid').length,
        duplicates: Object.values(newValidationResults).filter(status => status === 'duplicate').length
      };

      setValidationResults(newValidationResults);
      setScannerStats(stats);

    } catch (error) {
      console.error('Validation error:', error);
      toast.error('Failed to validate shipment numbers');
    } finally {
      setIsValidating(false);
    }
  }, []);

  const [loading, setLoading] = React.useState<boolean>(false);
  const [pageLoader, setPageLoader] = React.useState<boolean>(false);

  const [userData, setUserdata] = React.useState<any>({
    'manifest_name': "",
    'manifest_id': " ",
    'created_by': "",
    'sender_state': "",
    'destination_state': "",
    'shipment_status': "",
    'fleet_name': "null",
    'vehicle_name': "null",
    'goods_description': "",
    'pcs': "null",
    'weight': "null",
    'custom_value': "null",
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value, type } = e.target;
    setUserdata({ ...userData, [name]: value });
  };

  const [img1, setImg1] = React.useState('No selected file');
  const [img12, setImg12] = React.useState('empty');

  const [pdfManifestData, setPdfManifestData] = React.useState<any>(null);
  const [generatingPdfFor, setGeneratingPdfFor] = React.useState<string | null>(null);

  const handlePdfDownload = React.useCallback(async (manifestId: string) => {
    setGeneratingPdfFor(manifestId);
    try {
      const query: any = {
        search: '',
      };

      const response: any = await SuperAdminApis.getSingleRunManifest(manifestId, query);

      if (response?.data?.status && response?.data?.data) {
        const fullManifestData = {
          ...response.data.data.manifest,
          shipments: response.data.data.shipments || []
        };

        setPdfManifestData(fullManifestData);

        setTimeout(() => {
          setGeneratingPdfFor(null);
        }, 1000);

        return fullManifestData;
      } else {
        toast.error('Failed to load manifest data');
        setGeneratingPdfFor(null);
        return null;
      }
    } catch (error) {
      console.error('PDF download error:', error);
      toast.error('Failed to generate PDF');
      setGeneratingPdfFor(null);
      return null;
    }
  }, []);

  const ManifestPdfDownload = ({ manifest }: { manifest: any }) => {
    const [isLoading, setIsLoading] = React.useState(false);
    const [manifestData, setManifestData] = React.useState<any>(null);

    const handleDownloadClick = async () => {
      setIsLoading(true);

      try {
        const query: any = { search: '' };
        const response: any = await SuperAdminApis.getSingleRunManifest(manifest.id, query);

        if (response?.data?.status && response?.data?.data) {
          const fullData = {
            ...response.data.data.manifest,
            shipments: response.data.data.shipments || []
          };

          setManifestData(fullData);
        } else {
          toast.error('Failed to load manifest data');
          setIsLoading(false);
        }
      } catch (error) {
        console.error('PDF preparation error:', error);
        toast.error('Failed to prepare PDF');
        setIsLoading(false);
      }
    };

    React.useEffect(() => {
      setManifestData(null);
      setIsLoading(false);
    }, [manifest.id]);

    if (isLoading && !manifestData) {
      return (
        <div className="flex items-center gap-1">
          <Oval height="20" width="20" color="#E04343" secondaryColor="#FCBF94" />
          <span className="text-xs">Loading...</span>
        </div>
      );
    }

    if (manifestData) {
      return (
        <PDFDownloadLink
          document={<ShipmentManifest data={manifestData} />}
          fileName={`runway-manifest-${manifestData.manifest_id}.pdf`}
        >
          {({ loading }) => (
            loading ? (
              <div className="flex items-center gap-1">
                <Oval height="20" width="20" color="#E04343" secondaryColor="#FCBF94" />
                <span className="text-xs">Generating...</span>
              </div>
            ) : (
              <MdDownload size={24} className="text-green-600 hover:text-green-700 cursor-pointer" />
            )
          )}
        </PDFDownloadLink>
      );
    }

    return (
      <button
        onClick={handleDownloadClick}
        className="p-1 hover:bg-gray-100 rounded"
        title="Download PDF"
      >
        <MdDownload size={24} className="text-gray-600 hover:text-green-600" />
      </button>
    );
  };

  function uploadImg1(e: any) {
    let size = (e.target.files[0].size / 1048576.0)
    if (e.target.files && e.target.files[0]) {
      if (size > 10) {
        if (e.target.name == 'uploadImg1') {
          e.target.value = ''
          toast.warn('Image too large')
        }
      }
      if (size <= 10) {
        if (e.target.name == 'uploadImg1') {
          setImg1(e.target.files[0]);
          setImg12(URL.createObjectURL(e.target.files[0]))
        }
      }
    }
  };

  const updateShipment = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    let eventCode = '';
    setLoading(true);

    STATUSTYPES?.filter((data: any) => data?.EventName == shipmentStatus)?.map((datas: any, index: any) => {
      setShipmentStatusId(datas?.EventCode)
      eventCode = datas?.EventCode
    })

    let shiData = shipmentId;

    let shipment = [
      {
        "ThirdPartyToken": "null",
        "SenderDetails": {
          "SenderName": shiData?.SenderName ? shiData?.SenderName : 'null',
          "SenderCompanyName": shiData?.SenderCompanyName ? shiData?.SenderCompanyName : "null",
          "SenderCountryCode": shiData?.SenderCountryCode ? shiData?.SenderCountryCode : "null",
          "SenderAdd1": shiData?.SenderAdd1 ? shiData?.SenderAdd1 : "null",
          "SenderAdd2": shiData?.SenderAdd2 ? shiData?.SenderAdd2 : 'null',
          "SenderAdd3": shiData?.SenderAdd3 ? shiData?.SenderAdd3 : 'null',
          "SenderAddCity": shiData?.SenderAddCity ? shiData?.SenderAddCity : 'null',
          "SenderAddState": shiData?.SenderAddState ? shiData?.SenderAddState : 'null',
          "SenderAddPostcode": shiData?.SenderAddPostcode ? shiData?.SenderAddPostcode : 'null',
          "SenderPhone": shiData?.SenderPhone ? shiData?.SenderPhone : 'null',
          "SenderEmail": shiData?.SenderEmail ? shiData?.SenderEmail : 'null',
          "SenderFax": shiData?.SenderFax ? shiData?.SenderFax : 'null',
          "SenderKycType": shiData?.SenderKycType ? shiData?.SenderKycType : 'null',
          "SenderKycNumber": shiData?.SenderKycNumber ? shiData?.SenderKycNumber : 'null',
          "SenderReceivingCountryTaxID": shiData?.SenderReceivingCountryTaxID ? shiData?.SenderReceivingCountryTaxID : 'null'
        },
        "ReceiverDetails": {
          "ReceiverName": shiData?.ReceiverName ? shiData?.ReceiverName : 'null',
          "ReceiverCompanyName": shiData?.ReceiverCompanyName ? shiData?.ReceiverCompanyName : 'null',
          "ReceiverCountryCode": shiData?.ReceiverCountryCode ? shiData?.ReceiverCountryCode : 'null',
          "ReceiverAdd1": shiData?.ReceiverAdd1 ? shiData?.ReceiverAdd1 : 'null',
          "ReceiverAdd2": shiData?.ReceiverAdd2 ? shiData?.ReceiverAdd2 : 'null',
          "ReceiverAdd3": shiData?.ReceiverAdd3 ? shiData?.ReceiverAdd3 : 'null',
          "ReceiverAddCity": shiData?.ReceiverAddCity ? shiData?.ReceiverAddCity : 'null',
          "ReceiverAddState": shiData?.ReceiverAddState ? shiData?.ReceiverAddState : 'null',
          "ReceiverAddPostcode": shiData?.ReceiverAddPostcode ? shiData?.ReceiverAddPostcode : 'null',
          "ReceiverMobile": shiData?.ReceiverMobile ? shiData?.ReceiverMobile : 'null',
          "ReceiverPhone": shiData?.ReceiverPhone ? shiData?.ReceiverPhone : 'null',
          "ReceiverEmail": shiData?.ReceiverEmail ? shiData?.ReceiverEmail : 'null',
          "ReceiverAddResidential": shiData?.ReceiverAddResidential ? shiData?.ReceiverAddResidential : 'null',
          "ReceiverFax": shiData?.ReceiverFax ? shiData?.ReceiverFax : 'null',
          "ReceiverKycType": shiData?.ReceiverKycType ? shiData?.ReceiverKycType : 'null',
          "ReceiverKycNumber": shiData?.ReceiverKycNumber ? shiData?.ReceiverKycNumber : 'null'
        },
        "PackageDetails": {
          "GoodsDescription": shiData?.GoodsDescription ? shiData?.GoodsDescription : 'null',
          "CustomValue": shiData?.CustomValue ? shiData?.CustomValue : 0,
          "CustomCurrencyCode": shiData?.CustomCurrencyCode ? shiData?.CustomCurrencyCode : 'null',
          "InsuranceValue": shiData?.InsuranceValue ? shiData?.InsuranceValue : 0,
          "InsuranceCurrencyCode": shiData?.InsuranceCurrencyCode ? shiData?.InsuranceCurrencyCode : 'null',
          "ShipmentTerm": shiData?.ShipmentTerm ? shiData?.ShipmentTerm : 'null',
          "GoodsOriginCountryCode": shiData?.GoodsOriginCountryCode ? shiData?.GoodsOriginCountryCode : 'null',
          "DeliveryInstructions": delieveryInstruction ? delieveryInstruction : 'null',
          "Weight": shiData?.Weight ? shiData?.Weight : 0,
          "WeightMeasurement": shiData?.WeightMeasurement ? shiData?.WeightMeasurement : 'null',
          "NoOfItems": shiData?.NoOfItems ? shiData?.NoOfItems : 0,
          "CubicL": shiData?.CubicL ? shiData?.CubicL : 0,
          "CubicW": shiData?.CubicW ? shiData?.CubicW : 0,
          "CubicH": shiData?.CubicH ? shiData?.CubicH : 0,
          "CubicWeight": shiData?.CubicWeight ? shiData?.CubicWeight : 0,
          "ServiceTypeName": shiData?.ServiceTypeName ? shiData?.ServiceTypeName : 'null',
          "BookPickUP": false,
          "AlternateRef": shiData?.AlternateRef ? shiData?.AlternateRef : 'null',
          "SenderRef1": shiData?.SenderRef1 ? shiData?.SenderRef1 : 'null',
          "SenderRef2": shiData?.SenderRef2 ? shiData?.SenderRef2 : 'null',
          "SenderRef3": shiData?.SenderRef3 ? shiData?.SenderRef3 : 'null',
          "DeliveryAgentCode": shiData?.DeliveryAgentCode ? shiData?.DeliveryAgentCode : 'null',
          "DeliveryRouteCode": shiData?.DeliveryRouteCode ? shiData?.DeliveryRouteCode : 'null',
          "BusinessType": shiData?.BusinessType ? shiData?.BusinessType : 'B2B',
          "ShipmentResponseItem": [
            {
              "ItemAlt": "null",
              "ItemNoOfPcs": shiData?.NoOfItems ? shiData?.NoOfItems : 'null',
              "ItemCubicL": shiData?.CubicL ? shiData?.CubicL : 'null',
              "ItemCubicW": shiData?.CubicW ? shiData?.CubicW : 'null',
              "ItemCubicH": shiData?.CubicH ? shiData?.CubicH : 'null',
              "ItemWeight": shiData?.Weight ? shiData?.Weight : 'null',
              "ItemCubicWeight": shiData?.CubicWeight ? shiData?.CubicWeight : 'null',
              "ItemDescription": shiData?.GoodsDescription ? shiData?.GoodsDescription : 'null',
              "ItemCustomValue": shiData?.CustomValue ? shiData?.CustomValue : 'null',
              "ItemCustomCurrencyCode": shiData?.CustomCurrencyCode ? shiData?.CustomCurrencyCode : 'null',
              "Notes": shiData?.Notes ? shiData?.Notes : 'null'
            }
          ],
          "CODAmount": shiData?.CODAmount ? shiData?.CODAmount : 0,
          "CODCurrencyCode": shiData?.CODCurrencyCode ? shiData?.CODCurrencyCode : 'null',
          "Bag": shiData?.Bag ? shiData?.Bag : 0,
          "Notes": shiData?.Notes ? shiData?.Notes : 'null',
          "OriginLocCode": shiData?.OriginLocCode ? shiData?.OriginLocCode : 'null',
          "BagNumber": shiData?.BagNumber ? shiData?.BagNumber : 'null',
          "DeadWeight": shiData?.DeadWeight ? shiData?.DeadWeight : 0,
          "ReasonExport": shiData?.ReasonExport ? shiData?.ReasonExport : 'null',
          "DestTaxes": shiData?.DestTaxes ? shiData?.DestTaxes : 0,
          "Security": shiData?.Security ? shiData?.Security : 0,
          "Surcharge": shiData?.Surcharge ? shiData?.Surcharge : 0,
          "ReceiverTaxID": shiData?.ReceiverTaxID ? shiData?.ReceiverTaxID : 'null',
          "OrderNumber": shiData?.OrderNumber ? shiData?.OrderNumber : 0,
          "Incoterms": shiData?.Incoterms ? shiData?.Incoterms : 'null',
          "ClearanceReference": shiData?.ClearanceReference ? shiData?.ClearanceReference : 'null'
        }
      }
    ];

    const formData = new FormData()
    formData.append('Status', (shipmentStatus !== '' ? shipmentStatus : shipmentId?.status))
    formData.append('status_id', eventCode)
    formData.append('id', shipmentId?.id)
    formData.append('del_instruction', delieveryInstruction)
    formData.append('shiData', JSON.stringify(shipment))
    formData.append('delievery_code', canBypassCode ? 'bypass' : delieveryCode)
    formData.append('del_doc', img1)

    SuperAdminApis.updateShipmentStatusForDelivery(formData)
      .then((response: any) => {
        if (response?.data) {
          if (response?.data?.status) {
            toast.success(response?.data?.message);
            setStatusModal(false)
            setLoading(false);
            setShipmentStatus('')
            setImg1('No selected file')
            setDelieveryCode('')
            const query: any = {
              search: '',
            };

            SuperAdminApis.getSingleRunManifest(nextPageId, query).then(
              (response: AxiosResponse<any>) => {
                if (response?.data) {
                  setManifestData(response?.data?.data)
                  setDelieveryInstruction('');
                }
              }
            );

          } else {
            toast.warn(response?.data?.message);
            setStatusModal(false)
            setDelieveryInstruction('');
            setLoading(false);
            setShipmentStatus('')
          }
        }
      }).catch((err: any) => {
        console.log(err);
        setLoading(false);
      })
  };

  const getCurrentDateTime = (): string => {
    const now = new Date();
    const hours = now.getHours();
    const minutes = now.getMinutes().toString().padStart(2, '0');
    const seconds = now.getSeconds().toString().padStart(2, '0');
    const isAM = hours < 12;
    const formattedHours = (hours % 12 || 12).toString();
    const period = isAM ? 'am' : 'pm';
    const day = now.getDate().toString().padStart(2, '0');
    const month = (now.getMonth() + 1).toString().padStart(2, '0');
    const year = now.getFullYear();
    return `${formattedHours}:${minutes}:${seconds}`;
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    setRejectedNo('');

    const validShipments = barcodeValues.filter(barcode =>
      validationResults[barcode] === 'valid'
    );

    if (validShipments.length === 0) {
      toast.error('No valid shipments to add to manifest');
      setLoading(false);
      return;
    }

    if (validShipments.length !== barcodeValues.length) {
      const invalidCount = barcodeValues.length - validShipments.length;
      toast.warning(`${invalidCount} invalid/duplicate shipments will be excluded from manifest`);
    }

    try {
      // ✅ CHANGED: Increased batch size from 10 to 100 for better performance
      const batchSize = 20;
      const batches = [];
      for (let i = 0; i < validShipments.length; i += batchSize) {
        batches.push(validShipments.slice(i, i + batchSize));
      }

      let pics: any = 0;
      let count: any = 1;
      let randCode = Math.floor(Math.random() * Date.now()).toString(32);
      let manifestName = (userData?.manifest_name + '(' + getCurrentDateTime() + ')');

      // ✅ NEW: Track total API results across all batches
      let totalThirdPartyBatchesSent = 0;
      let totalThirdPartyShipmentsSent = 0;
      let allRejectedNumbers: string[] = [];

      for (const batch of batches) {
        const formData = new FormData();
        formData.append('manifest_name', manifestName);
        formData.append('manifest_id', randCode);
        formData.append('created_by', userLoginData?.data?.email);
        formData.append('event_location', userLoginData?.data?.office);
        formData.append('branch', userLoginData?.data?.branch);
        formData.append('shipment_status', userData?.shipment_status);
        formData.append('status_id', STATUSTYPES.find((data) => data?.EventName === userData?.shipment_status)?.EventCode || '');
        formData.append('fleet_name', shipmentRider?.target?.value);
        formData.append('shipment_ids', batch.toString());
        formData.append('vehicle_name', userData?.vehicle_name);
        formData.append('notes', userData?.goods_description);
        formData.append('pics', pics);
        formData.append('updated_at', eventDateTime);

        const response: any = await SuperAdminApis.createRunManifest(formData);
        if (!response.data.status || response.data.status == false) {
          throw new Error(response.data.message || 'Batch processing failed.');
        }

        // ✅ Accumulate third-party API results
        const apiResults = response?.data?.third_party_api_results;
        if (apiResults) {
          totalThirdPartyBatchesSent += apiResults.batches_sent || 0;
          totalThirdPartyShipmentsSent += apiResults.total_shipments_sent || 0;
        }

        let countedPics = parseInt(response?.data?.data?.pcs, 10);
        pics = countedPics;
        count += 1;

        // ✅ Accumulate rejected numbers
        if ((response?.data?.rejected_no)?.length >= 1) {
          allRejectedNumbers = [...allRejectedNumbers, ...response?.data?.rejected_no];
        }

        const percentage = ((count - 1) / batches.length) * 100;
        setPercentage(percentage);
      }

      // ✅ MOVED: Set rejected numbers AFTER the loop
      if (allRejectedNumbers.length >= 1) {
        setRejectedNo(allRejectedNumbers.toString());
      }

      // ✅ MOVED: Toast success AFTER the loop (shows only once)
      const apiMessage = totalThirdPartyBatchesSent > 0
        ? ` (${totalThirdPartyBatchesSent} API batches sent for ${totalThirdPartyShipmentsSent} shipments)`
        : '';
      toast.success(`Runway Manifest Created Successfully with ${validShipments.length} valid shipments!${apiMessage}`);

      const query: any = {
        search: searchText,
        type: 'date_range',
        date_from: dateFrom,
        date_to: dateTo
      };

      setLoading(false);
      setPageLoader(true);
      SuperAdminApis.getAllRunManifest('', query).then(
        (response: AxiosResponse<any>) => {
          if (response?.data) {
            setUserList(response?.data?.data)
          }
        }
      )

      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      setEventDateTime(`${year}-${month}-${day}T${hours}:${minutes}`);

    } catch (error: any) {
      // 🔄 MANIFEST-BLOCKING — Handle 422 (all shipments blocked)
      if (error?.response?.status === 422 && error?.response?.data?.error === 'ALL_SHIPMENTS_BLOCKED') {
        const blockedData = error.response.data;
        const blockedCount = blockedData.transition_blocked_count || 0;
        const blockedShipments = blockedData.transition_blocked_shipments || [];

        const reasons = blockedShipments.slice(0, 3).map(
          (s: any) => `${s.number}: ${s.current_status} (${s.reason})`
        );
        const moreCount = blockedShipments.length - 3;

        toast.error(
          `Runway manifest not created — all ${blockedCount} shipment(s) were blocked due to invalid status transitions.`

        );

        if (reasons.length > 0) {
          toast(
            reasons.join('\n') + (moreCount > 0 ? `\n...and ${moreCount} more` : ''),
            { icon: '🚫' }
          );
        }
      } else {
        toast.error(`Error: ${error?.response?.data?.message || error.message}`);
      }
    } finally {
      setLoading(false);
      setAddModal(false);
      setPageLoader(false);
      setPercentage(0);
      setBarcodeValues([]);
      setValidationResults({});
      setScannerStats({ total: 0, valid: 0, invalid: 0, duplicates: 0 });
    }
  };


  const [selectedManifests, setSelectedManifests] = React.useState<number[]>([]);
  const [isExportingBulk, setIsExportingBulk] = React.useState<boolean>(false);


  // Add helper function to check if all visible manifests are selected
  const areAllVisibleSelected = React.useMemo(() => {
    if (!userLists?.data || userLists.data.length === 0) return false;
    return userLists.data.every((manifest: any) => selectedManifests.includes(manifest.id));
  }, [selectedManifests, userLists?.data]);

  // Add toggle functions
  const toggleManifestSelection = (manifestId: number) => {
    setSelectedManifests(prev => {
      if (prev.includes(manifestId)) {
        return prev.filter(id => id !== manifestId);
      } else {
        return [...prev, manifestId];
      }
    });
  };

  const toggleAllManifests = () => {
    if (areAllVisibleSelected) {
      // Deselect all
      setSelectedManifests([]);
    } else {
      // Select all visible manifests
      const allVisibleIds = userLists?.data?.map((manifest: any) => manifest.id) || [];
      setSelectedManifests(allVisibleIds);
    }
  };


  // Add bulk export function
  const handleBulkExport = async () => {
    if (selectedManifests.length === 0) {
      toast.warning('Please select at least one manifest to export');
      return;
    }

    setIsExportingBulk(true);

    try {
      const response: any = await SuperAdminApis.exportMultipleRunwayManifests(selectedManifests);

      if (response?.data?.status && response?.data?.data?.shipments) {
        const shipments = response.data.data.shipments;
        const summary = response.data.data.summary;

        // Create Excel workbook
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(shipments);

        // Set column widths for better readability
        const colWidths = [
          { wch: 25 }, // Manifest Name
          { wch: 15 }, // Manifest ID
          { wch: 15 }, // Branch
          { wch: 15 }, // Event Location
          { wch: 15 }, // Fleet Name
          { wch: 15 }, // Rider Name
          { wch: 15 }, // Vehicle Name
          { wch: 20 }, // Manifest Status
          { wch: 25 }, // Manifest Created By
          { wch: 20 }, // Manifest Created At
          { wch: 12 }, // History Status
          { wch: 20 }, // Assigned At
          { wch: 20 }, // Moved At
          { wch: 20 }, // Moved To Manifest ID
          { wch: 25 }, // Moved To Manifest Name
          { wch: 30 }, // History Notes
          { wch: 18 }, // Shipment Number
          { wch: 20 }, // Current Status
          { wch: 15 }, // Delivery Code
          { wch: 20 }, // Sender Name
          { wch: 20 }, // Sender Company
          { wch: 15 }, // Sender Phone
          { wch: 25 }, // Sender Email
          { wch: 30 }, // Sender Address
          { wch: 15 }, // Sender City
          { wch: 15 }, // Sender State
          { wch: 10 }, // Sender Country
          { wch: 20 }, // Receiver Name
          { wch: 20 }, // Receiver Company
          { wch: 15 }, // Receiver Phone
          { wch: 15 }, // Receiver Mobile
          { wch: 25 }, // Receiver Email
          { wch: 30 }, // Receiver Address
          { wch: 15 }, // Receiver City
          { wch: 15 }, // Receiver State
          { wch: 10 }, // Receiver Country
          { wch: 10 }, // Weight
          { wch: 10 }, // Weight Unit
          { wch: 12 }, // Number of Items
          { wch: 30 }, // Goods Description
          { wch: 15 }, // Service Type
          { wch: 12 }, // Freight Cost
          { wch: 12 }, // Custom Value
          { wch: 12 }, // COD Amount
          { wch: 30 }, // Delivery Instructions
          { wch: 30 }, // Notes
          { wch: 20 }, // Shipment Created At
          { wch: 20 }, // Shipment Updated At
        ];
        worksheet['!cols'] = colWidths;

        XLSX.utils.book_append_sheet(workbook, worksheet, 'Runway Manifests Export');

        // Generate filename with timestamp and manifest count
        const timestamp = new Date().toISOString().split('T')[0];
        const fileName = `runway_manifests_bulk_export_${summary.total_manifests}_manifests_${summary.total_shipments}_shipments_${timestamp}.xlsx`;

        // Save file
        XLSX.writeFile(workbook, fileName);

        toast.success(
          `✅ Successfully exported ${summary.total_shipments} shipments from ${summary.total_manifests} manifests!`,
          { autoClose: 5000 }
        );

        // Clear selection after successful export
        setSelectedManifests([]);

      } else {
        toast.error('Failed to retrieve manifest data for export');
      }
    } catch (error: any) {
      console.error('Bulk export error:', error);
      toast.error(`Export failed: ${error?.response?.data?.message || 'Unknown error'}`);
    } finally {
      setIsExportingBulk(false);
    }
  };



  // Create this separate component OUTSIDE the main component (before the RunwayManifest function)
  const StatusUpdateModalContent = React.memo(({
    shipmentId,
    userLoginData,
    statusOptions,
    canBypassCode,
    manifestData, // Make sure this is passed from parent
    onClose,
    onSubmit
  }: any) => {
    const [shipmentStatus, setShipmentStatus] = React.useState<string>('');
    const [verOption, setVerOption] = React.useState<string>('');
    const [delieveryInstruction, setDelieveryInstruction] = React.useState<string>(shipmentId?.DeliveryInstructions || '');
    const [delieveryCode, setDelieveryCode] = React.useState<string>('');
    const [img1, setImg1] = React.useState('No selected file');
    const [img12, setImg12] = React.useState('empty');
    const [loading, setLoading] = React.useState(false);
    const [timeError, setTimeError] = React.useState<string>('');
    const uploadSectionRef = React.useRef<HTMLDivElement>(null);

    // Time state - will be set by useEffect when manifestData is available
    const [selectedTime, setSelectedTime] = React.useState<string>('');
    const [fixedDate, setFixedDate] = React.useState<string>('');
    const [minimumTimeString, setMinimumTimeString] = React.useState<string>('');
    const [manifestCreationTimeDisplay, setManifestCreationTimeDisplay] = React.useState<string>('');
    // The original manifest creation date (YYYY-MM-DD) — the earliest date allowed.
    const [manifestCreationDate, setManifestCreationDate] = React.useState<string>('');
    const todayStr = (() => {
      const d = new Date();
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    })();

    // useEffect to set date/time values when manifestData is available
    React.useEffect(() => {
      if (manifestData?.manifest?.created_at) {
        // Parse the manifest created_at datetime
        const manifestCreatedAt = new Date(manifestData.manifest.created_at);

        // Extract the fixed date (YYYY-MM-DD)
        const year = manifestCreatedAt.getFullYear();
        const month = String(manifestCreatedAt.getMonth() + 1).padStart(2, '0');
        const day = String(manifestCreatedAt.getDate()).padStart(2, '0');
        setFixedDate(`${year}-${month}-${day}`);
        setManifestCreationDate(`${year}-${month}-${day}`);

        // Store manifest creation time for display
        const creationHours = String(manifestCreatedAt.getHours()).padStart(2, '0');
        const creationMinutes = String(manifestCreatedAt.getMinutes()).padStart(2, '0');
        setManifestCreationTimeDisplay(`${creationHours}:${creationMinutes}`);

        // Calculate minimum time (1 hour after manifest creation)
        const minimumDateTime = new Date(manifestCreatedAt);
        minimumDateTime.setMinutes(minimumDateTime.getMinutes() + 5);

        const minHours = String(minimumDateTime.getHours()).padStart(2, '0');
        const minMinutes = String(minimumDateTime.getMinutes()).padStart(2, '0');
        const minTimeStr = `${minHours}:${minMinutes}`;

        setMinimumTimeString(minTimeStr);
        setSelectedTime(minTimeStr); // Default to minimum time

        // Debug log - remove in production
        console.log('Manifest created_at:', manifestData.manifest.created_at);
        console.log('Parsed manifestCreatedAt:', manifestCreatedAt);
        console.log('Fixed Date:', `${year}-${month}-${day}`);
        console.log('Creation Time:', `${creationHours}:${creationMinutes}`);
        console.log('Minimum Time (+1hr):', minTimeStr);
      }
    }, [manifestData?.manifest?.created_at]);

    // Helper function to format time for display (12-hour format)
    const formatTimeForDisplay = (time24: string): string => {
      if (!time24) return '';
      const [hours, minutes] = time24.split(':').map(Number);
      const period = hours >= 12 ? 'PM' : 'AM';
      const hours12 = hours % 12 || 12;
      return `${hours12}:${String(minutes).padStart(2, '0')} ${period}`;
    };

    // Helper function to format date for display
    const formatDateForDisplay = (dateStr: string): string => {
      if (!dateStr) return '';
      const [year, month, day] = dateStr.split('-');
      return `${month}/${day}/${year}`;
    };

    // Validate the combined date + time against the manifest creation floor.
    // The minimum (creation + 5 min) only bites when the chosen date is the
    // manifest creation date; a later date accepts any time.
    const validateDateTime = (dateStr: string, timeStr: string): string => {
      if (!dateStr || !timeStr || !manifestData?.manifest?.created_at) return '';
      const manifestCreatedAt = new Date(manifestData.manifest.created_at);
      const minDateTime = new Date(manifestCreatedAt.getTime() + 5 * 60000);
      const selected = new Date(`${dateStr}T${timeStr}`);
      if (isNaN(selected.getTime())) return '';
      if (selected < minDateTime) {
        return `Date/time must be on or after ${minDateTime.toLocaleString()} (5 minutes after the manifest was created).`;
      }
      return '';
    };

    // Handle date change with validation
    const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const newDate = e.target.value;
      setFixedDate(newDate);
      setTimeError(validateDateTime(newDate, selectedTime));
    };

    // Handle time change with validation
    const handleTimeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const newTime = e.target.value;
      setSelectedTime(newTime);
      setTimeError(validateDateTime(fixedDate, newTime));
    };

    // Combine date and time for submission
    const getUpdatedAtValue = (): string => {
      return `${fixedDate}T${selectedTime}`;
    };

    function uploadImg1(e: any) {
      let size = (e.target.files[0].size / 1048576.0)
      if (e.target.files && e.target.files[0]) {
        if (size > 10) {
          if (e.target.name == 'uploadImg1') {
            e.target.value = ''
            toast.warn('Image too large')
          }
        }
        if (size <= 10) {
          if (e.target.name == 'uploadImg1') {
            setImg1(e.target.files[0]);
            setImg12(URL.createObjectURL(e.target.files[0]))
          }
        }
      }
    }

    const handleSearchChange = (selectedOption: any) => {
      setShipmentStatus(selectedOption ? selectedOption?.value : '');
    };

    const handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();

      // Prevent submission if time is invalid
      if (timeError) {
        toast.error(timeError);
        return;
      }

      // Prevent submission if date/time not loaded yet
      if (!fixedDate || !selectedTime) {
        toast.error('Please wait for date/time to load');
        return;
      }

      const isShein = (shipmentId?.SenderName || '').toLowerCase().includes('shein');
      if (shipmentStatus === 'Proof of Delivery' && isShein && img1 === 'No selected file') {
        toast.error('A delivery photo is required for Shein shipments.');
        return;
      }

      onSubmit({
        shipmentStatus,
        delieveryInstruction,
        delieveryCode,
        img1,
        updatedAt: getUpdatedAtValue(),
        setLoading
      });
    };

    // Show loading state if manifest data not yet available
    if (!manifestData?.manifest?.created_at || !fixedDate || !selectedTime) {
      return (
        <div style={{ height: '100%' }} className="flex items-center justify-center">
          <div className="text-center p-4">
            <Oval
              visible={true}
              height="40"
              width="40"
              color="#E04343"
              secondaryColor="#FCBF94"
              ariaLabel="oval-loading"
            />
            <p className="mt-2 text-sm text-gray-600">Loading manifest data...</p>
          </div>
        </div>
      );
    }

    return (
      <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <div className="container bg-[#fff] rounded-lg p-2" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <div className="px-3" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <span className="flex justify-between px-2 pt-1 flex-shrink-0">
              <p className='mt-2'>Change Status</p>
              <p className="cursor-pointer font-bold" onClick={onClose}>
                <SvgElement type={icontypesEnum.CANCEL} />
              </p>
            </span>

            <form className="rounded-lg" onSubmit={handleFormSubmit} style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
              <div style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden', paddingRight: '2px' }}>
              <div className="relative w-full mt-5 mb-4">
                <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                  Status : ({shipmentId?.Status})
                </label>

                <div>
                  {/* {userLoginData?.data?.role == 'fleet' || userLoginData?.data?.role == 'driver' ? */}
                  <select
                    required
                    name='SenderCountryCode'
                    value={shipmentStatus}
                    onChange={(e) => setShipmentStatus(e.target.value)}
                    className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-r-[5px] block w-full p-2"
                  >
                    <option value="">--Select Status--</option>
                    <option value="Proof of Delivery">Proof of Delivery</option>
                    {/* <option value="Attempt to Contact Consignee Failed">Attempt to Contact Consignee Failed</option> */}
                    <option value="Attempted Delivery - Unable to Deliver - Other Reasons">Attempted Delivery - Unable to Deliver - Other Reasons</option>
                    {/* <option value="Not Delivered - Bad Weather Conditions">Not Delivered - Bad Weather Conditions</option> */}
                    {/* <option value="Attempted Delivery - No One Available/Home">Attempted Delivery - No One Available/Home</option> */}
                    {/* <option value="Attempted Delivery - Consignee Refused Delivery">Attempted Delivery - Consignee Refused Delivery</option> */}
                    {/* <option value="Attempted Delivery - Unable to Locate Consignee">Attempted Delivery - Unable to Locate Consignee</option> */}
                  </select>
                  {/* :
                     <Select
                    options={statusOptions}
                    onChange={handleSearchChange}
                    classNamePrefix="select"
                    isSearchable
                    placeholder="Filter by Status..."
                    isClearable
                  />
                       
                     
                   } */}

                  <div>
                    {/* Date & Time Section */}
                    <div className="w-full lg:w-12/12 mt-4">
                      <div className="relative w-full mb-2">
                        <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                          Update Date & Time <span className="text-gray-500 font-normal">(Editable)</span>
                        </label>

                        {/* Date Input (Editable) */}
                        <div className="mb-3">
                          <label className="block mb-1 text-xs font-medium text-gray-600">
                            Date (Adjustable)
                          </label>
                          <input
                            type="date"
                            value={fixedDate}
                            onChange={handleDateChange}
                            min={manifestCreationDate}
                            max={todayStr}
                            className="bg-white border border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3"
                          />
                          <p className="text-xs text-gray-500 mt-1">
                            Defaults to the manifest creation date ({formatDateForDisplay(manifestCreationDate)}). Adjust up to today if needed.
                          </p>
                        </div>

                        {/* Time Input (Editable with validation) */}
                        <div className="mb-2">
                          <label className="block mb-1 text-xs font-medium text-gray-600">
                            Time (Adjustable)
                          </label>
                          <input
                            type="time"
                            value={selectedTime}
                            onChange={handleTimeChange}
                            min={fixedDate === manifestCreationDate ? minimumTimeString : undefined}
                            className={`bg-white border text-[#333333] text-sm rounded-[5px] block w-full p-3 ${timeError ? 'border-red-500 focus:ring-red-500' : 'border-[#DADADA]'
                              }`}
                          />
                          {timeError ? (
                            <p className="text-xs text-red-500 mt-1">
                              {timeError}
                            </p>
                          ) : (
                            <p className="text-xs text-gray-500 mt-1">
                              {fixedDate === manifestCreationDate
                                ? `Minimum time: ${formatTimeForDisplay(minimumTimeString)} (5 minutes after manifest was created at ${formatTimeForDisplay(manifestCreationTimeDisplay)})`
                                : 'Any time on the selected date.'}
                            </p>
                          )}
                        </div>

                        {/* Combined DateTime Preview */}
                        <div className="bg-blue-50 border border-blue-200 rounded-[5px] p-2 mt-2">
                          <p className="text-xs text-blue-800">
                            <span className="font-semibold">Selected DateTime:</span> {formatDateForDisplay(fixedDate)} at {formatTimeForDisplay(selectedTime)}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="w-full lg:w-12/12 mt-2">
                      <div className="relative w-full mb-5">
                        <label htmlFor="delivery-notes-input" className="block mb-2 text-sm font-semibold text-[#19213D]">
                          Delivery Notes
                        </label>
                        <textarea
                          id="delivery-notes-input"
                          name="DeliveryInstructions"
                          required
                          value={delieveryInstruction}
                          onChange={(e) => setDelieveryInstruction(e.target.value)}
                          className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3"
                          placeholder="Write here..."
                          autoComplete="off"
                        >
                        </textarea>
                      </div>
                    </div>

                    {((shipmentStatus == 'Proof of Delivery' || shipmentId?.Status == 'Proof of Delivery') && !canBypassCode) ?
                      (() => {
                        const isShein = (shipmentId?.SenderName || '').toLowerCase().includes('shein');
                        return (
                          <div>
                            {isShein ? (
                              <>
                                <div className="mb-3 p-3 bg-orange-50 border border-orange-300 rounded-[5px]">
                                  <p className="text-sm font-semibold text-orange-700">Shein Shipment — Delivery Photo Required</p>
                                  <p className="text-xs text-orange-600 mt-1">A photo must be uploaded to confirm delivery of this Shein shipment.</p>
                                </div>
                                <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                  Delivery Photo <span className="text-red-500">*</span>
                                </label>
                                {img1 !== 'No selected file' ? (
                                  <div className="flex flex-col" style={{ border: '1px #E8E8E8 solid', borderRadius: '5px', padding: '5px 5px', marginBottom: '10px' }}>
                                    <div className='flex justify-end'>
                                      <label style={{ paddingTop: "4px", cursor: 'pointer' }}>
                                        <input className="hidden" onChange={uploadImg1} accept="image/x-png,image/jpeg" name='uploadImg1' type="file" />
                                        <SvgElement type={icontypesEnum.EDITPEN} />
                                      </label>
                                      <span className='ml-2' onClick={() => setImg1("No selected file")} style={{ cursor: 'pointer' }}>
                                        <svg width="24" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M4 8.00008H6.66667M6.66667 8.00008H28M6.66667 8.00008V26.6668C6.66667 27.374 6.94762 28.0523 7.44772 28.5524C7.94781 29.0525 8.62609 29.3334 9.33333 29.3334H22.6667C23.3739 29.3334 24.0522 29.0525 24.5523 28.5524C25.0524 28.0523 25.3333 27.374 25.3333 26.6668V8.00008H6.66667ZM10.6667 8.00008V5.33342C10.6667 4.62617 10.9476 3.94789 11.4477 3.4478C11.9478 2.9477 12.6261 2.66675 13.3333 2.66675H18.6667C19.3739 2.66675 20.0522 2.9477 20.5523 3.4478C21.0524 3.94789 21.3333 4.62617 21.3333 5.33342V8.00008M13.3333 14.6667V22.6668M18.6667 14.6667V22.6668" stroke="#EB0046" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                      </span>
                                    </div>
                                    <span className="flex justify-start">
                                      <img src={img12} alt="" style={{ width: '100%', height: '150px' }} />
                                    </span>
                                  </div>
                                ) : (
                                  <div className="w-full lg:w-12/12 mt-2">
                                    <label style={{ cursor: 'pointer' }}>
                                      <svg width="300" height="103" viewBox="0 0 478 103" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="1" y="1.5" width="476" height="100" rx="8" fill="#FFF7ED" />
                                        <rect x="1" y="1.5" width="476" height="100" rx="8" stroke="#F97316" strokeWidth="2" strokeLinecap="round" strokeDasharray="5 5" />
                                        <text fill="#C2410C" xmlSpace="preserve" style={{ whiteSpace: 'pre' }} fontFamily="Inter" fontSize="14" fontWeight="600" letterSpacing="0em"><tspan x="165" y="57">Click to Upload Photo</tspan></text>
                                        <text fill="#EA580C" xmlSpace="preserve" style={{ whiteSpace: 'pre' }} fontFamily="Inter" fontSize="12" letterSpacing="0em"><tspan x="177.096" y="80">PNG, JPG (Required)</tspan></text>
                                      </svg>
                                      <input className="hidden" onChange={uploadImg1} accept="image/x-png,image/gif,image/jpeg" name='uploadImg1' type="file" />
                                    </label>
                                  </div>
                                )}
                              </>
                            ) : (
                              <>
                                <label className="block mb-2 text-sm font-semibold text-[#19213D]">Select Proof Option</label>
                                <select
                                  onChange={(e) => {
                                    setVerOption(e.target.value);
                                    if (e.target.value === 'image') {
                                      setTimeout(() => uploadSectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' }), 50);
                                    }
                                  }}
                                  className="bg-white mb-3 border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-r-[5px] block w-full p-2"
                                >
                                  <option value=''>Please Select</option>
                                  <option value="image">Photo Upload</option>
                                  <option value="code">Code</option>
                                </select>

                                {verOption == 'image' ?
                                  (img1 !== 'No selected file' && verOption == 'image' ?
                                    <div ref={uploadSectionRef} className="flex flex-col" style={{ border: '1px #E8E8E8 solid', borderRadius: '5px', padding: '5px 5px', marginBottom: '10px' }}>
                                      <div className='flex justify-end'>
                                        <label style={{ paddingTop: "4px", cursor: 'pointer' }}>
                                          <input className="hidden" onChange={uploadImg1} accept="image/x-png,image/jpeg" name='uploadImg1' type="file" />
                                          <SvgElement type={icontypesEnum.EDITPEN} />
                                        </label>
                                        <span className='ml-2' onClick={() => setImg1("No selected file")} style={{ cursor: 'pointer' }}>
                                          <svg width="24" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4 8.00008H6.66667M6.66667 8.00008H28M6.66667 8.00008V26.6668C6.66667 27.374 6.94762 28.0523 7.44772 28.5524C7.94781 29.0525 8.62609 29.3334 9.33333 29.3334H22.6667C23.3739 29.3334 24.0522 29.0525 24.5523 28.5524C25.0524 28.0523 25.3333 27.374 25.3333 26.6668V8.00008H6.66667ZM10.6667 8.00008V5.33342C10.6667 4.62617 10.9476 3.94789 11.4477 3.4478C11.9478 2.9477 12.6261 2.66675 13.3333 2.66675H18.6667C19.3739 2.66675 20.0522 2.9477 20.5523 3.4478C21.0524 3.94789 21.3333 4.62617 21.3333 5.33342V8.00008M13.3333 14.6667V22.6668M18.6667 14.6667V22.6668" stroke="#EB0046" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                                          </svg>
                                        </span>
                                      </div>
                                      <span className="flex justify-start">
                                        <img src={img12} alt="" style={{ width: '100%', height: '150px' }} />
                                      </span>
                                    </div>
                                    :
                                    <div ref={uploadSectionRef} className="w-full lg:w-12/12 mt-2">
                                      <label style={{ cursor: 'pointer' }}>
                                        <svg width="300" height="103" viewBox="0 0 478 103" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <rect x="1" y="1.5" width="476" height="100" rx="8" fill="#F9FAFB" />
                                          <rect x="1" y="1.5" width="476" height="100" rx="8" stroke="#E5E7EB" strokeWidth="2" strokeLinecap="round" strokeDasharray="5 5" />
                                          <text fill="#6B7280" xmlSpace="preserve" style={{ whiteSpace: 'pre' }} fontFamily="Inter" fontSize="14" fontWeight="600" letterSpacing="0em"><tspan x="191.143" y="69.0909">Click to Upload</tspan></text>
                                          <text fill="#6B7280" xmlSpace="preserve" style={{ whiteSpace: 'pre' }} fontFamily="Inter" fontSize="12" letterSpacing="0em"><tspan x="177.096" y="93.3636">PNG, JPG(MAX. 500KB)</tspan></text>
                                        </svg>
                                        <input className="hidden" onChange={uploadImg1} accept="image/x-png,image/gif,image/jpeg" name='uploadImg1' type="file" />
                                      </label>
                                    </div>
                                  )
                                  : ''
                                }

                                {verOption == 'code' ?
                                  <div className="w-full lg:w-12/12">
                                    <div className="relative w-full mb-5">
                                      <label className="block mb-2 text-sm font-semibold text-[#19213D]">Delivery Code</label>
                                      <input
                                        required
                                        onChange={(e) => setDelieveryCode(e.target.value)}
                                        value={delieveryCode}
                                        className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3"
                                        placeholder="Write here..."
                                      />
                                    </div>
                                  </div>
                                  : ''
                                }
                              </>
                            )}
                          </div>
                        );
                      })()
                      : ''
                    }
                  </div>
                </div>
              </div>
              </div>{/* end scrollable content */}

              <div className="pb-4 flex-shrink-0">
              <span className="flex justify-center pt-4">
                <button
                  type="submit"
                  disabled={loading || !!timeError}
                  style={{ borderRadius: '50px', color: '#F52424' }}
                  className={`text-red-700 bg-red-200 focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm w-full px-2 py-2.5 text-center ${timeError ? 'opacity-50 cursor-not-allowed' : ''
                    }`}
                >
                  <div className="flex justify-center gap-3">
                    <span>Update</span>
                    <Oval
                      visible={loading}
                      height="20"
                      width="20"
                      color="#E04343"
                      secondaryColor="#FCBF94"
                      ariaLabel="oval-loading"
                    />
                  </div>
                </button>
              </span>

              <span className="flex justify-center pt-4">
                <button
                  type="button"
                  onClick={onClose}
                  style={{ borderRadius: '50px' }}
                  className="text-black focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm w-full px-2 py-1.5 text-center"
                >
                  Cancel
                </button>
              </span>
              </div>{/* end sticky footer */}
            </form>
          </div>
        </div>
      </div>
    );
  });

  StatusUpdateModalContent.displayName = 'StatusUpdateModalContent';

  const updateManifest = (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true)
    const formData = fleetData2
    SuperAdminApis.updateRunManifest(formData).then(
      (response: AxiosResponse<any>) => {
        if (response?.data) {
          if (response?.data?.status === true) {
            toast.success(response?.data?.message);
          }

        } else {
          toast.warn("Something went wrong,Try Again");
        }
        setLoading(false)
        setRiderModal(false)
        const query: any = {
          search: searchText,
          type: 'date_range',
          date_from: dateFrom,
          date_to: dateTo
        };
        SuperAdminApis.getAllRunManifest('', query).then(
          (response: AxiosResponse<any>) => {
            if (response?.data) {
              setUserList(response?.data?.data)
            }
          }
        )

        setUserdata([])
      }
    ).catch(function (error) {
      setLoading(false)
      toast.warn(error.response?.data?.message);
      toast.error("Offfline");
    }).finally(() => {
      setLoading(false)
    });
  };

  React.useEffect(() => {
    const query: any = {
      search: searchText,
      type: selectType,
      date_from: dateFrom,
      date_to: dateTo
    };

    SuperAdminApis.getAllFleetWithoutPagination('', query).then(
      (response: AxiosResponse<any>) => {
        if (response?.data) {
          setFleet(response?.data?.data?.data)
        }
      }
    ).catch(function (error) {
    })

    SuperAdminApis.getAllRunManifest('', query).then(
      (response: AxiosResponse<any>) => {
        if (response?.data) {
          setUserList(response?.data?.data)
        }
      }
    ).catch(function (error) {
    })

    let data = {
      "country_id": 2
    }
    SuperAdminApis.getAllStateFrom('', data).then(
      (response: AxiosResponse<any>) => {
        if (response?.data) {
          setStateFrom(response?.data?.data)
        }
      }
    )

    SuperAdminApis.getAllShipments('', '', '').then(
      (response: any) => {
        if (response?.data) {
          setShipmentInfo(response?.data?.in_bound?.data);
          setrunmanifestListData(response?.data?.run_manifest)
        }
      }
    )
  }, []);

  const selectShipment = (e: any) => {
    const { value, checked } = e.target;
    const { shipids } = shipid;

    if (checked) {
      setBarcodeValues((prev) => [...prev, value]);
      setShipId({
        shipids: [...shipids, value],
      });
    } else {
      setBarcodeValues((prev) => prev.filter((e: any) => e !== value));
      setShipId({
        shipids: shipids.filter((e: any) => e !== value)
      });
    }
  };

  const updateDesc = (e: any) => {
    const matchedData = riders?.find((datas: any) => datas?.id == e);

    if (matchedData) {
      const updatedData = {
        ...userData,
        ['goods_description']: `To be delivered by ${matchedData.first_name}`,
        ['manifest_name']: `${matchedData.first_name} - ${getCurrentDateTime()}`
      };
      setUserdata(updatedData);
    }
  };

  const nextPage = React.useCallback((id: any) => {

    setShipmentSearchText('');
    setActiveStatusFilter(null);
    const query: any = {
      search: '',
      type: selectType,
      date_from: dateFrom,
      date_to: dateTo
    };
    setNextPageId(id)
    setPageLoader(true);

    SuperAdminApis.getSingleRunManifest(id, query).then(
      (response: AxiosResponse<any>) => {
        console.log('✅ Single runway manifest response:', response?.data);

        if (response?.data?.status && response?.data?.data) {
          console.log('✅ Manifest data structure:', {
            manifest: response?.data?.data?.manifest,
            shipments: response?.data?.data?.shipments,
            shipment_counts: response?.data?.data?.shipment_counts
          });

          setManifestData(response?.data?.data);
          setTabNo('2');
        } else {
          console.error('❌ Invalid response structure:', response?.data);
          toast.error('Failed to load manifest details');
        }
      }
    ).catch(function (error) {
      console.error('❌ Error fetching single runway manifest:', error);
      toast.error('Error loading manifest details');
    }).finally(() => {
      setPageLoader(false);
    })
  }, [manifestData, tabNo, nextPageId, selectType]);

  const getAllVehicles = React.useCallback((id: any) => {
    const query: any = {
      search: searchText,
      type: selectType,
      date_from: dateFrom,
      date_to: dateTo
    };
    SuperAdminApis.getAllVehicle('', query, id).then(
      (response: AxiosResponse<any>) => {
        if (response?.data) {
          setVehicle(response?.data?.data?.data)
        }
      }
    ).catch(function (error) {
    })
  }, [vehicle]);

  const getAllRiders = React.useCallback((id: any) => {
    const query: any = {
      search: searchText,
      type: selectType,
      date_from: dateFrom,
      date_to: dateTo
    };
    SuperAdminApis.getAllRidersByFleet(id).then(
      (response: AxiosResponse<any>) => {
        if (response?.data) {
          setRiders(response?.data?.data)
        }
      }
    ).catch(function (error) {
    })
  }, [riders]);

  const handleBarcodeListChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = e.target.value;
    const updatedValues = newValue
      .split("\n")
      .map((item) => item.trim())
      .filter((item) => item !== "");

    setBarcodeValues(updatedValues);

    if (validationTimeout) {
      clearTimeout(validationTimeout);
    }

    const timeout = setTimeout(() => {
      validateShipmentNumbers(updatedValues);
    }, 500);

    setValidationTimeout(timeout);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCurrentInput(e.target.value.trim());
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" || e.keyCode === 13) {
      e.preventDefault();
      const value = currentInput.trim();
      if (value && !barcodeValues.includes(value)) {
        const newBarcodeValues = [...barcodeValues, value];
        setBarcodeValues(newBarcodeValues);
        setCurrentInput("");
        validateShipmentNumbers(newBarcodeValues);
      } else {
        setCurrentInput("");
      }
    }
  };

  const handleAddBarcode = React.useCallback(() => {
    const value = currentInput.trim();
    if (value && !barcodeValues.includes(value)) {
      const newBarcodeValues = [...barcodeValues, value];
      setBarcodeValues(newBarcodeValues);
      setCurrentInput("");
      validateShipmentNumbers(newBarcodeValues);
    } else if (value) {
      setCurrentInput("");
    }
  }, [currentInput, barcodeValues, validateShipmentNumbers]);

  const handleBarcodeFormSubmit = React.useCallback((e: React.FormEvent) => {
    e.preventDefault();
    handleAddBarcode();
  }, [handleAddBarcode]);

  const getValidationColor = (barcode: string) => {
    const status = validationResults[barcode];
    switch (status) {
      case 'valid': return 'text-green-600 bg-green-50';
      case 'invalid': return 'text-red-600 bg-red-50';
      case 'duplicate': return 'text-yellow-600 bg-yellow-50';
      default: return 'text-gray-600 bg-gray-50';
    }
  };

  const paginator = React.useCallback(
    (value: any) => {
      let value2 = '';
      if (value !== null) {
        value2 = value;
      } else {
        value2 = ''
      }
      const query: any = {
        search: searchText,
        type: selectType,
        date_from: dateFrom,
        date_to: dateTo
      };

      setPageLoader(true);

      SuperAdminApis.getAllRunManifest(value2, query).then(
        (response: AxiosResponse<any>) => {
          if (response?.data) {
            setPageLoader(false);
            setUserList(response?.data?.data)
          }
        }
      ).catch(function (error) {
        setPageLoader(false);
        console.log(error.response.data);
      })

    }, [userLists, searchText]);

  const paginator2 = React.useCallback(
    () => {
      const query: any = {
        search: searchText,
        type: selectType,
        date_from: dateFrom,
        date_to: dateTo
      };
      setPageLoader(true);

      SuperAdminApis.getSingleRunManifest(nextPageId, query).then(
        (response: AxiosResponse<any>) => {
          if (response?.data) {
            setManifestData(response?.data?.data)
            setPageLoader(false);
            setTabNo('2')
          }
        }
      );

    }, [manifestData, searchText2, nextPageId]);


  React.useEffect(() => {
    const query: any = {
      search: searchText,
      type: selectType,
      date_from: dateFrom,
      date_to: dateTo
    };
    setPageLoader(true);
    SuperAdminApis.getAllFleetWithoutPagination('', query).then(
      (response: AxiosResponse<any>) => {
        if (response?.data) {
          setFleet(response?.data?.data?.data)
        }
      }
    ).catch(function (error) {
    })

    SuperAdminApis.getAllRunManifest('', query).then(
      (response: AxiosResponse<any>) => {
        if (response?.data) {
          setUserList(response?.data?.data)
          setPageLoader(false);
        }
      }
    ).catch(function (error) {
      setPageLoader(false);
    })
  }, [selectType]);

  const applyDateFilter = () => {
    setSelectType('date_range');
    const query: any = {
      search: searchText,
      type: 'date_range',
      date_from: dateFrom,
      date_to: dateTo
    };

    SuperAdminApis.getAllRunManifest('', query).then(
      (response: AxiosResponse<any>) => {
        if (response?.data) {
          setUserList(response?.data?.data)
        }
      }
    );
  };

  const [shipType, setShipType] = React.useState<string>('event_location');

  type StateMapping = {
    [key: string]: string[];
  };

  const stateMappings: StateMapping = {
    "Ibadan": ["Kwara", "Ondo", "Ekiti", "Ogun", "Osun", "Oyo"],
    "Port Harcourt": ["Edo", "Cross River", "Akwa Ibom", "Delta", "Bayelsa"],
    "Enugu": ["Abia", "Anambra", "Imo", "Delta Asaba", "Ebonyi"],
    "Abuja": [
      "Kano", "Niger", "Kaduna", "Adamawa", "Kebbi", "Gombe", "Borno",
      "Bauchi", "Sokoto", "Zamfara", "Benue", "Jigawa", "Katsina",
      "Plateau", "Nassarawa", "Kogi", "Taraba", "Yobe"
    ]
  };

  const capitalize = (str: string): string =>
    str.replace(/\b\w/g, char => char.toUpperCase());

  const isSubStateUnderMainState = (mainState: string, subState: string): boolean => {
    if (mainState && subState) {
      const capitalizedMainState = capitalize(mainState.trim());
      const capitalizedSubState = capitalize(subState.trim());

      if (stateMappings[capitalizedMainState]) {
        return stateMappings[capitalizedMainState].includes(capitalizedSubState);
      }
    }
    return false;
  };

  const handleSearchChange = (selectedOption: any) => {
    setShipmentStatus(selectedOption ? selectedOption?.value : '');
  };

  const EnhancedRunwayBarcodeScanner = () => (
    <div className="p-4 border rounded-lg bg-white">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-xl font-bold">Enhanced Barcode Scanner</h1>
        {isValidating && (
          <div className="flex items-center text-blue-600">
            <Oval height="20" width="20" color="#3B82F6" secondaryColor="#93C5FD" />
            <span className="ml-2 text-sm">Validating...</span>
          </div>
        )}
      </div>

      <div className="grid grid-cols-4 gap-4 mb-4">
        <div className="bg-blue-50 p-3 rounded-lg text-center">
          <div className="text-2xl font-bold text-blue-600">{scannerStats.total}</div>
          <div className="text-sm text-blue-800">Total Scanned</div>
        </div>
        <div className="bg-green-50 p-3 rounded-lg text-center">
          <div className="text-2xl font-bold text-green-600">{scannerStats.valid}</div>
          <div className="text-sm text-green-800">Valid</div>
        </div>
        <div className="bg-red-50 p-3 rounded-lg text-center">
          <div className="text-2xl font-bold text-red-600">{scannerStats.invalid}</div>
          <div className="text-sm text-red-800">Invalid</div>
        </div>
        <div className="bg-yellow-50 p-3 rounded-lg text-center">
          <div className="text-2xl font-bold text-yellow-600">{scannerStats.duplicates}</div>
          <div className="text-sm text-yellow-800">Duplicates</div>
        </div>
      </div>

      <div className="mb-4">
        <label className="block text-gray-700 text-sm font-bold mb-2">
          Scan New Barcode: {barcodeValues.length} scanned
        </label>

        <form onSubmit={handleBarcodeFormSubmit} className="flex gap-2">
          <input
            type="number"
            value={currentInput}
            onChange={handleInputChange}
            onKeyDown={handleKeyPress}
            maxLength={12}
            placeholder="Scan a barcode and press Enter"
            autoComplete="off"
            autoFocus={addModal ? true : false}
            className="flex-1 px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#E04343]"
          />

          <button
            type="submit"
            onClick={(e) => {
              e.stopPropagation();
              handleAddBarcode();
            }}
            className="px-4 py-2 bg-[#E04343] text-white rounded-md hover:bg-red-600 transition-colors whitespace-nowrap"
          >
            Add
          </button>
        </form>

        <p className="text-xs text-gray-500 mt-1">
          Type or scan barcode, then press Enter or tap "Add"
        </p>
      </div>

      <div className="mb-4">
        <label className="block text-gray-700 text-sm font-bold mb-2">
          Scanned Barcodes with Validation Status:
        </label>
        <div className="border border-gray-300 rounded-md p-2 max-h-60 overflow-y-auto">
          {barcodeValues.length === 0 ? (
            <div className="text-gray-500 text-center py-4">No barcodes scanned yet</div>
          ) : (
            <div className="space-y-1">
              {barcodeValues.map((barcode, index) => (
                <div
                  key={index}
                  className={`flex items-center justify-between p-2 rounded ${getValidationColor(barcode)}`}
                >
                  <span className="font-mono">{barcode}</span>
                  <div className="flex items-center space-x-2">
                    {validationResults[barcode] === 'valid' && (
                      <span className="text-green-600">✓ Valid</span>
                    )}
                    {validationResults[barcode] === 'invalid' && (
                      <span className="text-red-600">✗ Invalid</span>
                    )}
                    {validationResults[barcode] === 'duplicate' && (
                      <span className="text-yellow-600">⚠ Duplicate</span>
                    )}
                    <button
                      onClick={() => {
                        const newValues = barcodeValues.filter((_, i) => i !== index);
                        setBarcodeValues(newValues);
                        validateShipmentNumbers(newValues);
                      }}
                      className="text-red-500 hover:text-red-700"
                    >
                      ✕
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <div className="mb-4">
        <label className="block text-gray-700 text-sm font-bold mb-2">
          Bulk Edit (One per line):
        </label>
        <textarea
          value={barcodeValues.join("\n")}
          onChange={handleBarcodeListChange}
          className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#E04343]"
          rows={5}
          placeholder="Enter shipment numbers, one per line"
        />
      </div>

      <div className="flex space-x-2 mb-4">
        <button
          type="button"
          onClick={() => {
            setBarcodeValues([]);
            setValidationResults({});
            setScannerStats({ total: 0, valid: 0, invalid: 0, duplicates: 0 });
          }}
          className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
        >
          Clear All
        </button>
        <button
          type="button"
          onClick={() => validateShipmentNumbers(barcodeValues)}
          disabled={isValidating || barcodeValues.length === 0}
          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:opacity-50"
        >
          Re-validate
        </button>
        <button
          type="button"
          onClick={() => {
            const validOnly = barcodeValues.filter(barcode =>
              validationResults[barcode] === 'valid'
            );
            setBarcodeValues(validOnly);
            validateShipmentNumbers(validOnly);
            toast.success(`Removed ${barcodeValues.length - validOnly.length} invalid/duplicate shipments`);
          }}
          disabled={scannerStats.invalid === 0 && scannerStats.duplicates === 0}
          className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 disabled:opacity-50"
        >
          Remove Invalid ({scannerStats.invalid + scannerStats.duplicates})
        </button>
      </div>

      <p className="text-sm text-gray-500">
        Scan barcodes or type them manually. Valid shipments will be highlighted in green,
        invalid ones in red, and duplicates in yellow. Click the ✕ to remove individual items.
      </p>
    </div>
  );

  return (
    <>
      <AdminSidebar title="Run Way Manifests" />
      <div className="relative md:ml-64 bg-[#FAFAFA] ">
        <AdminNavbar title="Run Way Manifest" />

        {tabNo == "1" ?
          <div className='lg:px-10 pb-6 px-4 bg-[#FAFAFA] min-h-screen'>

            <div className='flex flex-col md:flex-row md:justify-between md:items-center my-5 gap-4'>
              <div>
                <h3 className='text-[15px] md:text-[18px] text-[#1C1C1C] font-semibold'>Runway Manifest</h3>
              </div>

              <div className='flex justify-end w-full md:w-auto'>
                <div className="relative flex w-full md:w-64 flex-wrap items-stretch">
                  <div className="absolute inset-y-0 right-2 flex items-center pl-3 pointer-events-none">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                      <path fill="#9da4aa" d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0a5.5 5.5 0 0 1 11 0z" />
                    </svg>
                  </div>
                  <input
                    type="text"
                    // onClick={() => paginator('')}
                    onChange={(e: any) => setSearchText(e.target.value)}
                    value={searchText}
                    placeholder='search...'
                    // id="simple-search"
                    className="border border-gray-300 text-gray-500 text-sm rounded-md block w-full pl-4 pr-10 p-1"
                    required
                  />
                </div>
                <div className='mt-0.5 ml-2'>
                  <button
                    type='button'
                    onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => paginator('')}
                    className="font-normal text-white bg-[#E04343] px-3 py-0.5 rounded-md text-sm"
                  >
                    Search
                  </button>
                </div>
              </div>
            </div>

            <div className='space-y-3 mt-4'>

              <div className='flex flex-col sm:flex-row sm:justify-between gap-2'>
                <div className='flex-1'>
                  {selectedManifests.length > 0 && (
                    <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                      <p className="text-sm text-blue-800 font-medium">
                        {selectedManifests.length} manifest{selectedManifests.length > 1 ? 's' : ''} selected
                      </p>
                    </div>
                  )}
                </div>

                <div className='flex gap-2'>
                  {selectedManifests.length > 0 && (
                    <button
                      type='button'
                      onClick={handleBulkExport}
                      disabled={isExportingBulk}
                      className="font-medium text-white bg-green-600 px-5 py-2 rounded-md text-sm hover:bg-green-700 transition-colors flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      {isExportingBulk ? (
                        <>
                          <Oval height="20" width="20" color="#ffffff" secondaryColor="#cccccc" />
                          <span>Exporting...</span>
                        </>
                      ) : (
                        <>
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                          </svg>
                          <span>Bulk Export ({selectedManifests.length})</span>
                        </>
                      )}
                    </button>
                  )}

                  <button
                    type='button'
                    onClick={() => setAddModal(true)}
                    className="font-medium text-white bg-[#E04343] px-5 py-2 rounded-md text-sm hover:bg-[#c93939] transition-colors flex-1 sm:flex-initial"
                  >
                    Create
                  </button>
                  <button
                    type='button'
                    onClick={() => exportManifestData(userLists?.data)}
                    className="font-medium text-white bg-[#E04343] px-5 py-2 rounded-md text-sm hover:bg-[#c93939] transition-colors flex-1 sm:flex-initial"
                  >
                    Export
                  </button>
                </div>
              </div>

              <div className='flex gap-2'>
                <button
                  type='button'
                  onClick={() => setSelectType('today')}
                  className={`font-medium px-4 py-2 rounded-md text-sm transition-colors flex-1 ${selectType === 'today'
                    ? 'text-white bg-[#E04343]'
                    : 'text-[#E04343] bg-white border border-[#E04343] hover:bg-red-50'
                    }`}
                >
                  Today
                </button>
                <button
                  type='button'
                  onClick={() => setSelectType('all')}
                  className={`font-medium px-4 py-2 rounded-md text-sm transition-colors flex-1 ${selectType === 'all'
                    ? 'text-white bg-[#E04343]'
                    : 'text-[#E04343] bg-white border border-[#E04343] hover:bg-red-50'
                    }`}
                >
                  All
                </button>
              </div>

              <div className='border border-gray-200 rounded-lg p-3 bg-gray-50'>
                <p className='text-xs font-medium text-gray-700 mb-2'>Filter by Date Range</p>

                <div className='flex flex-col gap-2'>
                  <div className='flex gap-2'>
                    <div className='flex-1'>
                      <label htmlFor="dateFrom" className="text-xs text-gray-600 mb-1 block">
                        From
                      </label>
                      <input
                        id="dateFrom"
                        type="date"
                        value={dateFrom}
                        onChange={(e) => setDateFrom(e.target.value)}
                        className="border border-gray-300 text-gray-700 text-sm rounded-md p-2 w-full bg-white"
                      />
                    </div>

                    <div className='flex-1'>
                      <label htmlFor="dateTo" className="text-xs text-gray-600 mb-1 block">
                        To
                      </label>
                      <input
                        id="dateTo"
                        type="date"
                        value={dateTo}
                        onChange={(e) => setDateTo(e.target.value)}
                        className="border border-gray-300 text-gray-700 text-sm rounded-md p-2 w-full bg-white"
                      />
                    </div>
                  </div>

                  <button
                    type='button'
                    onClick={() => applyDateFilter()}
                    className="font-medium text-white bg-[#E04343] px-4 py-2 rounded-md text-sm hover:bg-[#c93939] transition-colors w-full"
                  >
                    Apply Date Filter
                  </button>
                </div>
              </div>
            </div>

            {rejectedNo?.length >= 1 && (
              <div className='flex justify-start mt-4'>
                <span className='text-[13px] sm:text-[15px] font-[500] text-red-600 bg-red-50 px-3 py-2 rounded-md'>
                  Rejected shipment: [{rejectedNo}]
                </span>
              </div>
            )}

            {pageLoader ? (
              <div className="flex justify-center items-center mt-[20vh]">
                <div>
                  <Oval
                    visible={true}
                    height="80"
                    width="80"
                    color="#E04343"
                    secondaryColor="#FCBF94"
                    ariaLabel="oval-loading"
                  />
                </div>
              </div>
            ) : (
              <>
                <div className="mt-6">
                  <div className="hidden lg:block relative overflow-x-auto">
                    <table className="w-full text-sm text-left rtl:text-right text-gray-500 border-separate border-spacing-y-3">
                      <thead className="text-[12px] text-[#030229] bg-[#FAFAFA]">
                        <tr>
                          <th scope="col" className="px-2 py-2">
                            <input
                              type="checkbox"
                              checked={areAllVisibleSelected}
                              onChange={toggleAllManifests}
                              className="w-4 h-4 accent-[#E04343] cursor-pointer"
                            />
                          </th>
                          <th scope="col" className="px-2 py-2">S/N</th>
                          <th scope="col" className="px-2 py-2">Manifest Name</th>
                          <th scope="col" className="px-2 py-2">Manifest Id</th>
                          <th scope="col" className="px-2 py-2">Created By</th>
                          <th scope="col" className="px-2 py-2">Created Date</th>
                          <th scope="col" className="px-2 py-2">Branch</th>
                          <th scope="col" className="px-2 py-2">Event Location</th>
                          <th scope="col" className="px-2 py-2">Shipment Status</th>
                          <th scope="col" className="px-2 py-4">Fleet</th>
                          <th scope="col" className="px-2 py-4">Notes</th>
                          <th scope="col" className="px-2 py-4">Pcs</th>
                          <th scope="col" className="px-8 py-4">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(userLoginData?.data?.role == 'admin' || userLoginData?.data?.role == 'fleet' || userLoginData?.data?.role == 'driver' ?
                          (userLists?.data?.length > 0 ?
                            userLists?.data?.map((datas: any, index: any) => (
                              <tr className="bg-white" key={index}>
                                <td className="px-2 py-2">
                                  <input
                                    type="checkbox"
                                    checked={selectedManifests.includes(datas.id)}
                                    onChange={() => toggleManifestSelection(datas.id)}
                                    className="w-4 h-4 accent-[#E04343] cursor-pointer"
                                  />
                                </td>
                                <td className="px-2 py-2">{index + 1}</td>
                                <td className="px-2 py-4">{datas?.manifest_name}</td>
                                <td className="px-2 py-4">{datas?.manifest_id}</td>
                                <td className="px-2 py-4">{datas?.created_by}</td>
                                <td className="px-2 py-4">{convertUTCDateToLocalDate(datas.created_at)}</td>
                                <td className="px-2 py-4">{datas?.branch || 'N/A'}</td>
                                <td className="px-2 py-4">{datas?.event_location}</td>
                                <td className="px-2 py-4">{datas?.shipment_status}</td>
                                <td className="px-2 py-4">{datas?.fleet_name}</td>
                                <td className="px-2 py-4">{datas?.Notes}</td>
                                <td className="px-2 py-4">{datas?.pcs}</td>
                                <td className='flex justify-between gap-3 px-6 py-4'>
                                  {userLoginData?.data?.role == 'fleet' || userLoginData?.data?.role == 'driver' ? null : (
                                    <span className="hover:underline text-blue-500 cursor-pointer" onClick={() => { setRiderModal(true); setFleetData2(datas) }}>
                                      Edit
                                    </span>
                                  )}

                                  <ManifestPdfDownload manifest={datas} />

                                  <span className="cursor-pointer" onClick={(e: any) => { nextPage(datas?.id); }}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <rect width="24" height="24" rx="4" fill="#EBEBEB" />
                                      <path d="M12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5Z" fill="#3F83F8" />
                                      <path d="M15.2536 9.30891C14.2289 8.60625 13.1323 8.25 11.9944 8.25C10.9704 8.25 9.97219 8.55469 9.02742 9.15187C8.07469 9.75539 7.1407 10.8516 6.375 12C6.99422 13.0312 7.84125 14.0916 8.72344 14.6995C9.73547 15.3966 10.8359 15.75 11.9944 15.75C13.1428 15.75 14.2409 15.3968 15.2592 14.7002C16.1557 14.0859 17.0088 13.027 17.625 12C17.0067 10.9821 16.1508 9.92437 15.2536 9.30891ZM12 14.25C11.555 14.25 11.12 14.118 10.75 13.8708C10.38 13.6236 10.0916 13.2722 9.92127 12.861C9.75097 12.4499 9.70642 11.9975 9.79323 11.561C9.88005 11.1246 10.0943 10.7237 10.409 10.409C10.7237 10.0943 11.1246 9.88005 11.561 9.79323C11.9975 9.70642 12.4499 9.75097 12.861 9.92127C13.2722 10.0916 13.6236 10.38 13.8708 10.75C14.118 11.12 14.25 11.555 14.25 12C14.2493 12.5965 14.012 13.1684 13.5902 13.5902C13.1684 14.012 12.5965 14.2493 12 14.25Z" fill="#3F83F8" />
                                    </svg>
                                  </span>
                                </td>
                              </tr>
                            ))
                            :
                            <tr>
                              <td colSpan={13} className="text-center py-8 text-gray-500">No Record Found</td>
                            </tr>)
                          :
                          // Similar structure for non-admin users
                          (userLists?.data?.length > 0 ?
                            userLists?.data?.map((datas: any, index: any) => (
                              <tr className="bg-white" key={index}>
                                <td className="px-2 py-2">
                                  <input
                                    type="checkbox"
                                    checked={selectedManifests.includes(datas.id)}
                                    onChange={() => toggleManifestSelection(datas.id)}
                                    className="w-4 h-4 accent-[#E04343] cursor-pointer"
                                  />
                                </td>
                                <td className="px-2 py-2">{index + 1}</td>
                                <td className="px-2 py-4">{datas?.manifest_name}</td>
                                <td className="px-2 py-4">{datas?.manifest_id}</td>
                                <td className="px-2 py-4">{datas?.created_by}</td>
                                <td className="px-2 py-4">{convertUTCDateToLocalDate(datas.created_at)}</td>
                                <td className="px-2 py-4">{datas?.branch || 'N/A'}</td>
                                <td className="px-2 py-4">{datas?.event_location}</td>
                                <td className="px-2 py-4">{datas?.shipment_status}</td>
                                <td className="px-2 py-4">{datas?.fleet_name}</td>
                                <td className="px-2 py-4">{datas?.Notes}</td>
                                <td className="px-2 py-4">{datas?.pcs}</td>
                                <td className='flex justify-between gap-3 px-6 py-4'>
                                  <span className="hover:underline text-blue-500 cursor-pointer" onClick={() => { setRiderModal(true); setFleetData2(datas) }}>
                                    Edit
                                  </span>

                                  <ManifestPdfDownload manifest={datas} />

                                  <span className="cursor-pointer" onClick={(e: any) => { nextPage(datas?.id); }}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <rect width="24" height="24" rx="4" fill="#EBEBEB" />
                                      <path d="M12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5Z" fill="#3F83F8" />
                                      <path d="M15.2536 9.30891C14.2289 8.60625 13.1323 8.25 11.9944 8.25C10.9704 8.25 9.97219 8.55469 9.02742 9.15187C8.07469 9.75539 7.1407 10.8516 6.375 12C6.99422 13.0312 7.84125 14.0916 8.72344 14.6995C9.73547 15.3966 10.8359 15.75 11.9944 15.75C13.1428 15.75 14.2409 15.3968 15.2592 14.7002C16.1557 14.0859 17.0088 13.027 17.625 12C17.0067 10.9821 16.1508 9.92437 15.2536 9.30891ZM12 14.25C11.555 14.25 11.12 14.118 10.75 13.8708C10.38 13.6236 10.0916 13.2722 9.92127 12.861C9.75097 12.4499 9.70642 11.9975 9.79323 11.561C9.88005 11.1246 10.0943 10.7237 10.409 10.409C10.7237 10.0943 11.1246 9.88005 11.561 9.79323C11.9975 9.70642 12.4499 9.75097 12.861 9.92127C13.2722 10.0916 13.6236 10.38 13.8708 10.75C14.118 11.12 14.25 11.555 14.25 12C14.2493 12.5965 14.012 13.1684 13.5902 13.5902C13.1684 14.012 12.5965 14.2493 12 14.25Z" fill="#3F83F8" />
                                    </svg>
                                  </span>
                                </td>
                              </tr>
                            ))
                            :
                            <tr>
                              <td colSpan={13} className="text-center py-8 text-gray-500">No Record Found</td>
                            </tr>)
                        )}
                      </tbody>
                    </table>
                  </div>

                  <div className="lg:hidden space-y-4">
                    {(userLoginData?.data?.role == 'admin' || userLoginData?.data?.role == 'fleet' || userLoginData?.data?.role == 'driver' ?
                      userLists?.data :
                      userLists?.data
                    )?.map((datas: any, index: any) => (
                      <div key={index} className="bg-white rounded-lg shadow-sm p-4 border border-gray-200">
                        <div className="flex justify-between items-start mb-3">
                          <div className="flex items-start gap-3 flex-1">
                            <input
                              type="checkbox"
                              checked={selectedManifests.includes(datas.id)}
                              onChange={() => toggleManifestSelection(datas.id)}
                              className="w-5 h-5 accent-[#E04343] cursor-pointer mt-1"
                            />
                            <div className="flex-1">
                              <h4 className="font-semibold text-[#030229] text-sm mb-1">{datas?.manifest_name}</h4>
                              <p className="text-xs text-gray-500">ID: {datas?.manifest_id}</p>
                            </div>
                          </div>
                          <span className="bg-[#E04343] text-white text-xs px-2 py-1 rounded">#{index + 1}</span>
                        </div>

                        <div className="space-y-2 text-sm">
                          <div className="flex justify-between">
                            <span className="text-gray-600">Created By:</span>
                            <span className="font-medium text-gray-900">{datas?.created_by}</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600">Date:</span>
                            <span className="font-medium text-gray-900">{convertUTCDateToLocalDate(datas.created_at)}</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600">Branch:</span>
                            <span className="font-medium text-gray-900">{datas?.branch || 'N/A'}</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600">Location:</span>
                            <span className="font-medium text-gray-900">{datas?.event_location}</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600">Status:</span>
                            <span className="font-medium text-gray-900">{datas?.shipment_status}</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600">Fleet:</span>
                            <span className="font-medium text-gray-900">{datas?.fleet_name}</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600">Pieces:</span>
                            <span className="font-medium text-gray-900">{datas?.pcs}</span>
                          </div>
                          {datas?.Notes && (
                            <div className="pt-2 border-t border-gray-100">
                              <span className="text-gray-600 text-xs">Notes:</span>
                              <p className="text-gray-900 text-xs mt-1">{datas?.Notes}</p>
                            </div>
                          )}
                        </div>

                        <div className="flex gap-2 mt-4 pt-3 border-t border-gray-100">
                          {!(userLoginData?.data?.role == 'fleet' || userLoginData?.data?.role == 'driver') && (
                            <button
                              onClick={() => { setRiderModal(true); setFleetData2(datas) }}
                              className="flex-1 bg-blue-50 text-blue-600 text-sm font-medium py-2 px-3 rounded-md hover:bg-blue-100 transition-colors"
                            >
                              Edit
                            </button>
                          )}

                          <div className="flex-1">
                            <ManifestPdfDownload manifest={datas} />
                          </div>

                          <button
                            onClick={() => { nextPage(datas?.id); }}
                            className="flex-1 bg-gray-50 text-gray-600 text-sm font-medium py-2 px-3 rounded-md hover:bg-gray-100 transition-colors"
                          >
                            View Details
                          </button>
                        </div>
                      </div>
                    ))}

                    {userLists?.data?.length === 0 && (
                      <div className="text-center py-12 bg-white rounded-lg">
                        <p className="text-gray-500">No Record Found</p>
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}

            <div className='mt-6 flex flex-wrap justify-center gap-1'>
              {userLists?.links?.filter((item: any, idx: any) => idx < 1000).map((datas: any, index: any) => (
                <button
                  key={index}
                  onClick={() => paginator(datas?.label == 'Next &raquo;' ? datas?.url?.charAt(datas?.url?.length - 1) : (datas?.label === '&laquo; Previous') ? datas?.url?.charAt(datas?.url?.length - 1) : datas?.label)}
                  disabled={datas?.active}
                  className={'py-1.5 px-3 text-sm rounded ' + ((datas?.active == false || datas?.url == null) ? 'bg-gray-300 text-black' : 'bg-[#E04343] text-white')}
                >
                  {datas?.label == '&laquo; Previous' ? '< Prev' : (datas?.label === 'Next &raquo;') ? 'Next >' : datas?.label}
                </button>
              ))}
            </div>
          </div>
          : null
        }

        {tabNo == "2" ?
          <div className=' lg:px-10 pb-6 px-6 bg-[#FAFAFA] min-h-screen'>
            <div className='flex flex-col gap-4 my-5'>
              <div>
                <h3 className='text-[15px] md:text-[18px] text-[#1C1C1C] font-semibold capitalize'>
                  Shipments under {manifestData?.manifest?.manifest_name || 'Unknown Manifest'}
                </h3>

                <div className='flex flex-wrap gap-x-3 gap-y-1 mt-2 text-xs sm:text-sm text-gray-600'>
                  <span className='flex items-center'>
                    <span className='font-semibold mr-1'>Manifest ID:</span>
                    <span className='break-all'>{manifestData?.manifest?.manifest_id}</span>
                  </span>
                  <span className='hidden sm:inline'>|</span>
                  <span className='flex items-center'>
                    <span className='font-semibold mr-1'>Active:</span>
                    <span className='bg-green-100 text-green-800 px-2 py-0.5 rounded-full text-xs'>
                      {manifestData?.shipment_counts?.active || 0}
                    </span>
                  </span>

                  <span className='hidden sm:inline'>|</span>
                  <span className='flex items-center'>
                    <span className='font-semibold mr-1'>Total History:</span>
                    <span className='bg-blue-100 text-blue-800 px-2 py-0.5 rounded-full text-xs'>
                      {manifestData?.shipment_counts?.total_history || 0}
                    </span>
                  </span>
                </div>
              </div>

              <div className='flex flex-col sm:flex-row gap-2'>
                <button
                  onClick={handleShipmentExport}
                  disabled={loading || !manifestData?.shipments?.length}
                  className="bg-green-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-green-700 disabled:opacity-50 transition-colors flex items-center justify-center gap-2 w-full sm:w-auto"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M17 8l-5-5-5 5M12 3v12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  <span className='hidden sm:inline'>
                    {loading ? 'Exporting...' : `Export ${manifestData?.shipments?.length || 0} Shipments`}
                  </span>
                  <span className='sm:hidden'>
                    {loading ? 'Exporting...' : `Export (${manifestData?.shipments?.length || 0})`}
                  </span>
                </button>

                <button
                  type='button'
                  onClick={() => setTabNo('1')}
                  className="font-normal text-white bg-[#E04343] px-4 py-2 rounded-md text-sm hover:bg-red-600 transition-colors w-full sm:w-auto"
                >
                  ← Go Back
                </button>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
              <div className="bg-green-50 p-4 rounded-lg shadow-sm border border-green-200">
                <div className="flex items-center justify-between">
                  <div>
                    <div className="text-2xl font-bold text-green-600">
                      {manifestData?.shipment_counts?.active || 0}
                    </div>
                    <div className="text-sm text-green-800">Active Shipments</div>
                  </div>
                  <div className="text-green-600">
                    <svg width="32" height="32" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                  </div>
                </div>
              </div>

              <div className="bg-yellow-50 p-4 rounded-lg shadow-sm border border-yellow-200">
                <div className="flex items-center justify-between">
                  <div>
                    <div className="text-2xl font-bold text-yellow-600">
                      {manifestData?.shipment_counts?.moved || 0}
                    </div>
                    <div className="text-sm text-yellow-800">Moved Shipments</div>
                  </div>
                  <div className="text-yellow-600">
                    <svg width="32" height="32" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v3.586L7.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 10.586V7z" clipRule="evenodd" />
                    </svg>
                  </div>
                </div>
              </div>

              <div className="bg-blue-50 p-4 rounded-lg shadow-sm border border-blue-200">
                <div className="flex items-center justify-between">
                  <div>
                    <div className="text-2xl font-bold text-blue-600">
                      {manifestData?.shipment_counts?.total_history || 0}
                    </div>
                    <div className="text-sm text-blue-800">Total History</div>
                  </div>
                  <div className="text-blue-600">
                    <svg width="32" height="32" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm5 6a1 1 0 10-2 0v3.586l-1.293-1.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 11.586V8z" clipRule="evenodd" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>



            {/* Status Breakdown Section */}
            {/* Status Breakdown Section - Now Clickable for Filtering */}
            {manifestData?.shipments && manifestData.shipments.length > 0 && (() => {
              // Calculate status breakdown for active shipments only
              const activeShipments = manifestData.shipments.filter((s: any) => s.history_status === 'active');
              const statusCounts: { [key: string]: number } = {};

              activeShipments.forEach((shipment: any) => {
                const status = shipment?.Status || shipment?.status || 'Unknown';
                statusCounts[status] = (statusCounts[status] || 0) + 1;
              });

              // Sort by count descending
              const sortedStatuses = Object.entries(statusCounts).sort((a, b) => b[1] - a[1]);

              // Helper function to get status color
              const getStatusColor = (status: string, isActive: boolean) => {
                const lowerStatus = status.toLowerCase();
                const baseColors = {
                  delivery: isActive ? 'bg-green-200 text-green-900 border-green-400 ring-2 ring-green-500' : 'bg-green-100 text-green-800 border-green-300',
                  transit: isActive ? 'bg-blue-200 text-blue-900 border-blue-400 ring-2 ring-blue-500' : 'bg-blue-100 text-blue-800 border-blue-300',
                  review: isActive ? 'bg-yellow-200 text-yellow-900 border-yellow-400 ring-2 ring-yellow-500' : 'bg-yellow-100 text-yellow-800 border-yellow-300',
                  failed: isActive ? 'bg-red-200 text-red-900 border-red-400 ring-2 ring-red-500' : 'bg-red-100 text-red-800 border-red-300',
                  arrived: isActive ? 'bg-purple-200 text-purple-900 border-purple-400 ring-2 ring-purple-500' : 'bg-purple-100 text-purple-800 border-purple-300',
                  default: isActive ? 'bg-gray-200 text-gray-900 border-gray-400 ring-2 ring-gray-500' : 'bg-gray-100 text-gray-800 border-gray-300',
                };

                if (lowerStatus.includes('delivery') || lowerStatus.includes('delivered')) {
                  return baseColors.delivery;
                } else if (lowerStatus.includes('transit') || lowerStatus.includes('out for')) {
                  return baseColors.transit;
                } else if (lowerStatus.includes('review') || lowerStatus.includes('pending')) {
                  return baseColors.review;
                } else if (lowerStatus.includes('failed') || lowerStatus.includes('unable')) {
                  return baseColors.failed;
                } else if (lowerStatus.includes('arrived') || lowerStatus.includes('hub')) {
                  return baseColors.arrived;
                } else {
                  return baseColors.default;
                }
              };

              const handleStatusClick = (status: string) => {
                if (activeStatusFilter === status) {
                  setActiveStatusFilter(null); // Toggle off if already selected
                } else {
                  setActiveStatusFilter(status); // Set new filter
                }
              };

              return sortedStatuses.length > 0 ? (
                <div className="mb-4 bg-white rounded-lg shadow-sm border border-gray-200 p-4">
                  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 mb-3">
                    <h4 className="text-sm font-semibold text-gray-700 flex items-center">
                      <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M2 11a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5zM8 7a1 1 0 011-1h2a1 1 0 011 1v9a1 1 0 01-1 1H9a1 1 0 01-1-1V7zM14 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V4z" />
                      </svg>
                      Quick Filter by Status
                      <span className="ml-2 text-xs font-normal text-gray-500">(Click to filter)</span>
                    </h4>
                    {activeStatusFilter && (
                      <button
                        onClick={() => setActiveStatusFilter(null)}
                        className="text-xs text-red-600 hover:text-red-800 flex items-center gap-1 bg-red-50 px-2 py-1 rounded-full"
                      >
                        <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                        </svg>
                        Clear Filter
                      </button>
                    )}
                  </div>

                  {/* Desktop view - flex wrap */}
                  <div className="hidden sm:flex flex-wrap gap-2">
                    {sortedStatuses.map(([status, count]) => (
                      <button
                        key={status}
                        onClick={() => handleStatusClick(status)}
                        className={`inline-flex items-center px-3 py-2 rounded-lg text-sm font-medium border cursor-pointer transition-all hover:shadow-md ${getStatusColor(status, activeStatusFilter === status)}`}
                      >
                        {activeStatusFilter === status && (
                          <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                          </svg>
                        )}
                        <span className="font-semibold">{status}</span>
                        <span className="ml-2 px-2 py-0.5 rounded-full bg-white bg-opacity-50 text-xs font-bold">
                          {count}
                        </span>
                      </button>
                    ))}
                  </div>

                  {/* Mobile view - horizontal scroll */}
                  <div className="sm:hidden overflow-x-auto">
                    <div className="flex gap-2 pb-2" style={{ minWidth: 'max-content' }}>
                      {sortedStatuses.map(([status, count]) => (
                        <button
                          key={status}
                          onClick={() => handleStatusClick(status)}
                          className={`inline-flex items-center px-3 py-2 rounded-lg text-sm font-medium border whitespace-nowrap cursor-pointer transition-all ${getStatusColor(status, activeStatusFilter === status)}`}
                        >
                          {activeStatusFilter === status && (
                            <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                            </svg>
                          )}
                          <span className="font-semibold">{status}</span>
                          <span className="ml-2 px-2 py-0.5 rounded-full bg-white bg-opacity-50 text-xs font-bold">
                            {count}
                          </span>
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              ) : null;
            })()}


            {/* Search Box for Shipments */}
            <div className="mb-4 bg-white rounded-lg shadow-sm border border-gray-200 p-4">
              <div className="flex flex-col sm:flex-row gap-3">
                {/* Search Input */}
                <div className="flex-1">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Search Shipments
                  </label>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                      </svg>
                    </div>
                    <input
                      type="text"
                      value={shipmentSearchText}
                      onChange={(e) => setShipmentSearchText(e.target.value)}
                      placeholder="Search by name, phone, address, shipment number..."
                      className="block w-full pl-10 pr-10 py-2.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-[#E04343] focus:border-[#E04343] transition-colors"
                    />
                    {shipmentSearchText && (
                      <button
                        onClick={() => setShipmentSearchText('')}
                        className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600"
                      >
                        <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                        </svg>
                      </button>
                    )}
                  </div>
                </div>

                {/* Filter Summary */}
                <div className="flex items-end">
                  <div className="bg-gray-50 rounded-lg px-4 py-2.5 border border-gray-200">
                    <div className="flex items-center gap-2 text-sm">
                      <span className="text-gray-600">Showing:</span>
                      <span className="font-bold text-[#E04343]">{filteredShipments.length}</span>
                      <span className="text-gray-600">of</span>
                      <span className="font-bold text-gray-800">{manifestData?.shipments?.length || 0}</span>
                      <span className="text-gray-600">shipments</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Active Filters Display */}
              {(shipmentSearchText || activeStatusFilter) && (
                <div className="mt-3 flex flex-wrap items-center gap-2">
                  <span className="text-xs text-gray-500">Active filters:</span>

                  {activeStatusFilter && (
                    <span className="inline-flex items-center gap-1 px-2 py-1 bg-blue-100 text-blue-800 rounded-full text-xs font-medium">
                      Status: {activeStatusFilter}
                      <button
                        onClick={() => setActiveStatusFilter(null)}
                        className="hover:text-blue-600"
                      >
                        <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                        </svg>
                      </button>
                    </span>
                  )}

                  {shipmentSearchText && (
                    <span className="inline-flex items-center gap-1 px-2 py-1 bg-purple-100 text-purple-800 rounded-full text-xs font-medium">
                      Search: "{shipmentSearchText}"
                      <button
                        onClick={() => setShipmentSearchText('')}
                        className="hover:text-purple-600"
                      >
                        <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                        </svg>
                      </button>
                    </span>
                  )}

                  <button
                    onClick={() => {
                      setShipmentSearchText('');
                      setActiveStatusFilter(null);
                    }}
                    className="text-xs text-red-600 hover:text-red-800 underline ml-2"
                  >
                    Clear all filters
                  </button>
                </div>
              )}
            </div>

            {pageLoader ? (
              <div className="flex justify-center items-center mt-[20vh]">
                <div className="text-center">
                  <Oval
                    visible={true}
                    height="80"
                    width="80"
                    color="#E04343"
                    secondaryColor="#FCBF94"
                    ariaLabel="oval-loading"
                  />
                  <p className="mt-4 text-gray-600">Loading shipment details...</p>
                </div>
              </div>
            ) : (
              <>
                <div className="hidden lg:block relative overflow-x-auto">
                  <table className="w-full text-sm text-left rtl:text-right text-gray-500 border-separate border-spacing-y-3">
                    <thead className="text-[12px] text-[#808080] bg-[#FAFAFA]">
                      <tr>
                        <th scope="col" className="px-2 py-2">S/N</th>
                        <th scope="col" className="px-2 py-2">Status Badge</th>
                        <th scope="col" className="px-2 py-2">Receiver Name</th>
                        <th scope="col" className="px-2 py-2">Receiver Phone</th>
                        <th scope="col" className="px-2 py-2">Receiver Address</th>
                        <th scope="col" className="px-2 py-2">Status</th>
                        <th scope="col" className="px-2 py-2">Shipment Number</th>
                        <th scope="col" className="px-2 py-2">Event Date</th>
                        <th scope="col" className="px-2 py-2">Deadline</th>
                        <th scope="col" className="px-2 py-2">Fleet</th>
                        <th scope="col" className="px-2 py-2">Vehicle</th>
                        <th scope="col" className="px-2 py-2">Pcs</th>
                        <th scope="col" className="px-2 py-2">Upload</th>
                        <th scope="col" className="px-2 py-2">Moved Info</th>
                      </tr>
                    </thead>

                    <tbody>
                      {filteredShipments?.length > 0 ? (
                        filteredShipments?.map((shipment: any, index: number) => (
                          <tr
                            key={shipment.id || index}
                            className={`${shipment.history_status === 'moved'
                              ? 'bg-yellow-50 border-l-4 border-yellow-400'
                              : 'bg-white'
                              }`}
                          >
                            <td className="px-2 py-2">{index + 1}</td>

                            <td className="px-2 py-2">
                              {shipment.history_status === 'active' ? (
                                <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800 border border-green-200">
                                  <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                  </svg>
                                  Active
                                </span>
                              ) : (
                                <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800 border border-yellow-200">
                                  <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                  </svg>
                                  Moved
                                </span>
                              )}
                            </td>

                            <td className="px-6 py-4">{shipment?.ReceiverName}</td>
                            <td className="px-6 py-4">{shipment?.ReceiverPhone}</td>
                            <td className="px-6 py-4">{shipment?.ReceiverAdd1}</td>

                            {shipment.history_status === 'moved' ?
                              <td className="px-2 py-2">
                                {(shipment?.Status == 'inReview' || shipment?.Status == 'InReview') ?
                                  <p><b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#FFDDBD', color: '#F29339', borderRadius: '10px', padding: '2px 10px' }}>{shipment?.Status}</b></p> :
                                  <p><b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#C9F0D0', color: '#51CF66', borderRadius: '10px', padding: '2px 10px' }}>{shipment?.Status}</b></p>
                                }
                              </td>
                              :
                              <td className="px-2 py-2 cursor-pointer" onClick={() => { toggleStatus(); setShipmentId(shipment); setDelieveryInstruction(shipment?.DeliveryInstructions || '') }}>
                                {(shipment?.Status == 'inReview' || shipment?.Status == 'InReview') ?
                                  <p><b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#FFDDBD', color: '#F29339', borderRadius: '10px', padding: '2px 10px' }}>{shipment?.Status}</b></p> :
                                  <p><b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#C9F0D0', color: '#51CF66', borderRadius: '10px', padding: '2px 10px' }}>{shipment?.Status}</b></p>
                                }
                              </td>
                            }

                            <td className="px-6 py-4">{shipment?.ShipmentNumber ? shipment?.ShipmentNumber : `Not Available`}</td>
                            <td className="px-2 py-2">
                              <div className="flex flex-col">
                                <span className="text-xs">
                                  {shipment?.event_datetime
                                    ? new Date(shipment.event_datetime).toLocaleString()
                                    : new Date(shipment?.updated_at).toLocaleString()}
                                </span>
                                {shipment?.is_date_manually_set && (
                                  <span className="inline-flex items-center mt-1 px-2 py-0.5 rounded-full text-xs font-medium bg-orange-100 text-orange-800 border border-orange-200">
                                    <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                                    </svg>
                                    Manual
                                  </span>
                                )}
                                {shipment?.date_set_by && shipment?.is_date_manually_set && (
                                  <span className="text-xs text-gray-500 mt-0.5" title={`Set by: ${shipment.date_set_by}`}>
                                    by: {shipment.date_set_by?.split('@')[0]}
                                  </span>
                                )}
                              </div>
                            </td>

                            <td className="px-2 py-2">
                              {(() => {
                                const deadlineInfo = getDeadlineStatus(shipment?.dead_line);
                                return (
                                  <div className="flex flex-col items-start">
                                    <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium border ${deadlineInfo.bgColor} ${deadlineInfo.textColor} ${deadlineInfo.borderColor}`}>
                                      {deadlineInfo.status === 'expired' && (
                                        <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                                        </svg>
                                      )}
                                      {deadlineInfo.status === 'critical' && (
                                        <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                          <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                        </svg>
                                      )}
                                      {deadlineInfo.status === 'warning' && (
                                        <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                                        </svg>
                                      )}
                                      {deadlineInfo.status === 'safe' && shipment?.dead_line && (
                                        <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                        </svg>
                                      )}
                                      {deadlineInfo.text}
                                    </span>
                                    {shipment?.dead_line && deadlineInfo.status !== 'expired' && (
                                      <span className="text-xs text-gray-500 mt-1">
                                        {new Date(shipment.dead_line).toLocaleDateString('en-US', {
                                          month: 'short',
                                          day: 'numeric',
                                          hour: '2-digit',
                                          minute: '2-digit'
                                        })}
                                      </span>
                                    )}
                                  </div>
                                );
                              })()}
                            </td>


                            <td className="px-6 py-4 cursor-pointer">{manifestData?.manifest?.fleet_name ? manifestData?.manifest?.fleet_name : "No Fleet"}</td>
                            <td className="px-6 py-4">{shipment?.vehicle_name ? shipment?.vehicle_name : "No Vehicle"}</td>
                            <td className="px-6 py-4">{shipment?.NoOfItems}</td>

                            {(shipment?.del_doc !== null && shipment?.del_doc !== 'No selected file') ?
                              <td className="px-6 py-4">
                                <a href={shipment?.del_doc} target="_blank" rel="noopener noreferrer" className='underline text-blue-500'>View</a>
                              </td>
                              :
                              <td className="px-6 py-4">{shipment?.Status == 'Proof of Delivery' ? shipment?.delievery_code : '--'}</td>
                            }

                            <td className="px-6 py-4">
                              {shipment.history_status === 'moved' ? (
                                <div className="text-xs">
                                  <div className="font-semibold text-yellow-800 mb-1">Moved to:</div>
                                  <div className="text-yellow-700 mb-1">{shipment.moved_to_manifest_name || 'Unknown Manifest'}</div>
                                  <div className="text-gray-500">ID: {shipment.moved_to_manifest_id || 'N/A'}</div>
                                  {shipment.moved_at && (
                                    <div className="text-gray-500 mt-1">
                                      {new Date(shipment.moved_at).toLocaleDateString()}
                                    </div>
                                  )}
                                </div>
                              ) : (
                                <span className="text-gray-400 text-xs">Currently active</span>
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={12} className="text-center py-8 text-gray-500">
                            {filteredShipments?.length === 0 && (
                              <tr>
                                <td colSpan={14} className="text-center py-8">
                                  {manifestData?.shipments?.length > 0 ? (
                                    <div className="text-gray-500">
                                      <svg className="w-12 h-12 mx-auto mb-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                      </svg>
                                      <p className="font-medium">No shipments match your search</p>
                                      <p className="text-sm mt-1">
                                        Try adjusting your search terms or
                                        <button
                                          onClick={() => {
                                            setShipmentSearchText('');
                                            setActiveStatusFilter(null);
                                          }}
                                          className="text-[#E04343] hover:underline ml-1"
                                        >
                                          clear all filters
                                        </button>
                                      </p>
                                    </div>
                                  ) : (
                                    <p className="text-gray-500">No shipments found for this manifest.</p>
                                  )}
                                </td>
                              </tr>
                            )}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                <div className="lg:hidden space-y-4">
                  {filteredShipments?.length > 0 ? (
                    filteredShipments?.map((shipment: any, index: number) => (
                      <div
                        key={shipment.id || index}
                        className={`rounded-lg shadow-sm p-4 border-2 ${shipment.history_status === 'moved'
                          ? 'bg-yellow-50 border-yellow-400'
                          : 'bg-white border-gray-200'
                          }`}
                      >
                        <div className="flex justify-between items-start mb-3 pb-3 border-b border-gray-200">
                          <div>
                            <div className="flex items-center gap-2 mb-2">
                              <span className="bg-[#E04343] text-white text-xs font-bold px-2 py-1 rounded">
                                #{index + 1}
                              </span>
                              {shipment.history_status === 'active' ? (
                                <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800 border border-green-200">
                                  <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                  </svg>
                                  Active
                                </span>
                              ) : (
                                <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800 border border-yellow-200">
                                  <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                  </svg>
                                  Moved
                                </span>
                              )}
                            </div>
                            <h4 className="font-semibold text-gray-900 text-sm">
                              {shipment?.ShipmentNumber || 'Not Available'}
                            </h4>
                          </div>

                          <button
                            onClick={() => { toggleStatus(); setShipmentId(shipment); setDelieveryInstruction(shipment?.DeliveryInstructions || '') }}
                            className="cursor-pointer"
                            disabled={shipment.history_status === 'moved'}
                          >
                            {(shipment?.Status == 'inReview' || shipment?.Status == 'InReview') ? (
                              <span className="inline-block text-xs font-medium bg-[#FFDDBD] text-[#F29339] px-3 py-1.5 rounded-lg">
                                {shipment?.Status}
                              </span>
                            ) : (
                              <span className="inline-block text-xs font-medium bg-[#C9F0D0] text-[#51CF66] px-3 py-1.5 rounded-lg">
                                {shipment?.Status}
                              </span>
                            )}
                          </button>
                        </div>

                        <div className="space-y-2 mb-3">
                          <div className="bg-gray-50 p-3 rounded-lg">
                            <h5 className="text-xs font-semibold text-gray-700 mb-2 uppercase">Receiver Details</h5>
                            <div className="space-y-1.5 text-sm">
                              <div className="flex justify-between">
                                <span className="text-gray-600">Name:</span>
                                <span className="font-medium text-gray-900 text-right">{shipment?.ReceiverName}</span>
                              </div>


                              <div className="bg-orange-50 p-2 rounded col-span-2">
                                <span className="text-gray-600 text-xs block">Event Date</span>
                                <span className="font-medium text-gray-900 text-xs">
                                  {shipment?.event_datetime
                                    ? new Date(shipment.event_datetime).toLocaleString()
                                    : new Date(shipment?.updated_at).toLocaleString()}
                                </span>
                                {shipment?.is_date_manually_set && (
                                  <div className="mt-1">
                                    <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-orange-100 text-orange-800 border border-orange-200">
                                      <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                                      </svg>
                                      Manually Set
                                    </span>
                                    {shipment?.date_set_by && (
                                      <p className="text-xs text-gray-500 mt-0.5">
                                        by: {shipment.date_set_by}
                                      </p>
                                    )}
                                  </div>
                                )}
                              </div>
                              <div className="flex justify-between">
                                <span className="text-gray-600">Phone:</span>
                                <a href={`tel:${shipment?.ReceiverPhone}`} className="font-medium text-blue-600 hover:underline">
                                  {shipment?.ReceiverPhone}
                                </a>
                              </div>
                              <div className="flex flex-col">
                                <span className="text-gray-600 mb-1">Address:</span>
                                <span className="font-medium text-gray-900 text-sm">{shipment?.ReceiverAdd1}</span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="grid grid-cols-2 gap-2 text-sm mb-3">
                          <div className="bg-blue-50 p-2 rounded">
                            <span className="text-gray-600 text-xs block">Fleet</span>
                            <span className="font-medium text-gray-900 text-xs">
                              {manifestData?.manifest?.fleet_name || 'No Fleet'}
                            </span>
                          </div>
                          <div className="bg-blue-50 p-2 rounded">
                            <span className="text-gray-600 text-xs block">Vehicle</span>
                            <span className="font-medium text-gray-900 text-xs">
                              {shipment?.vehicle_name || 'No Vehicle'}
                            </span>
                          </div>
                          <div className="bg-purple-50 p-2 rounded">
                            <span className="text-gray-600 text-xs block">Pieces</span>
                            <span className="font-medium text-gray-900 text-xs">{shipment?.NoOfItems || 0}</span>
                          </div>
                          <div className="bg-purple-50 p-2 rounded">
                            <span className="text-gray-600 text-xs block">Upload/Code</span>
                            {(shipment?.del_doc !== null && shipment?.del_doc !== 'No selected file') ? (
                              <a
                                href={shipment?.del_doc}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-600 hover:underline text-xs font-medium"
                              >
                                View Doc
                              </a>
                            ) : (
                              <span className="font-medium text-gray-900 text-xs">
                                {shipment?.Status == 'Proof of Delivery' ? shipment?.delievery_code : '--'}
                              </span>
                            )}
                          </div>
                        </div>

                        {/* Deadline Section */}
                        <div className="mb-3">
                          {(() => {
                            const deadlineInfo = getDeadlineStatus(shipment?.dead_line);
                            return (
                              <div className={`p-3 rounded-lg border ${deadlineInfo.bgColor} ${deadlineInfo.borderColor}`}>
                                <div className="flex items-center justify-between">
                                  <div className="flex items-center gap-2">
                                    {deadlineInfo.status === 'expired' && (
                                      <svg className={`w-5 h-5 ${deadlineInfo.textColor}`} fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                                      </svg>
                                    )}
                                    {deadlineInfo.status === 'critical' && (
                                      <svg className={`w-5 h-5 ${deadlineInfo.textColor}`} fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                      </svg>
                                    )}
                                    {deadlineInfo.status === 'warning' && (
                                      <svg className={`w-5 h-5 ${deadlineInfo.textColor}`} fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                                      </svg>
                                    )}
                                    {deadlineInfo.status === 'safe' && shipment?.dead_line && (
                                      <svg className={`w-5 h-5 ${deadlineInfo.textColor}`} fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                      </svg>
                                    )}
                                    {!shipment?.dead_line && (
                                      <svg className={`w-5 h-5 ${deadlineInfo.textColor}`} fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                                      </svg>
                                    )}
                                    <div>
                                      <span className={`text-xs font-semibold ${deadlineInfo.textColor}`}>Deadline</span>
                                      <p className={`text-sm font-bold ${deadlineInfo.textColor}`}>{deadlineInfo.text}</p>
                                    </div>
                                  </div>
                                  {shipment?.dead_line && (
                                    <div className="text-right">
                                      <span className={`text-xs ${deadlineInfo.textColor}`}>
                                        {new Date(shipment.dead_line).toLocaleDateString('en-US', {
                                          month: 'short',
                                          day: 'numeric',
                                        })}
                                      </span>
                                      <p className={`text-xs ${deadlineInfo.textColor}`}>
                                        {new Date(shipment.dead_line).toLocaleTimeString('en-US', {
                                          hour: '2-digit',
                                          minute: '2-digit',
                                        })}
                                      </p>
                                    </div>
                                  )}
                                </div>
                              </div>
                            );
                          })()}
                        </div>

                        {shipment.history_status === 'moved' && (
                          <div className="bg-yellow-100 border border-yellow-300 rounded-lg p-3 mt-3">
                            <div className="flex items-start gap-2">
                              <svg className="w-5 h-5 text-yellow-700 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                              </svg>
                              <div className="flex-1">
                                <p className="text-xs font-semibold text-yellow-800 mb-1">Moved to:</p>
                                <p className="text-xs text-yellow-700 font-medium">
                                  {shipment.moved_to_manifest_name || 'Unknown Manifest'}
                                </p>
                                <p className="text-xs text-gray-600 mt-1">
                                  ID: {shipment.moved_to_manifest_id || 'N/A'}
                                </p>
                                {shipment.moved_at && (
                                  <p className="text-xs text-gray-600 mt-1">
                                    Date: {new Date(shipment.moved_at).toLocaleDateString()}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                        )}

                        {shipment.history_status === 'active' && (
                          <div className="bg-green-50 border border-green-200 rounded-lg p-2 mt-3">
                            <p className="text-xs text-green-700 text-center font-medium">
                              ✓ Currently Active in Manifest
                            </p>
                          </div>
                        )}
                      </div>
                    ))
                  ) : (
                    <div className="text-center py-12 bg-white rounded-lg border border-gray-200">
                      <svg className="w-16 h-16 mx-auto text-gray-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
                      </svg>
                      <p className="text-gray-500">
                        {filteredShipments?.length === 0 && (
                          <div className="text-center py-12 bg-white rounded-lg border border-gray-200">
                            {manifestData?.shipments?.length > 0 ? (
                              <div className="px-4">
                                <svg className="w-16 h-16 mx-auto text-gray-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                </svg>
                                <p className="text-gray-600 font-medium">No shipments match your search</p>
                                <p className="text-gray-500 text-sm mt-2">
                                  Try adjusting your search terms or filters
                                </p>
                                <button
                                  onClick={() => {
                                    setShipmentSearchText('');
                                    setActiveStatusFilter(null);
                                  }}
                                  className="mt-3 text-[#E04343] hover:underline text-sm font-medium"
                                >
                                  Clear all filters
                                </button>
                              </div>
                            ) : (
                              <>
                                <svg className="w-16 h-16 mx-auto text-gray-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
                                </svg>
                                <p className="text-gray-500">No shipments found for this manifest.</p>
                              </>
                            )}
                          </div>
                        )}
                      </p>
                    </div>
                  )}
                </div>
              </>
            )}

            {manifestData && (
              <div className="mt-6 bg-white p-4 rounded-lg shadow-sm">
                <h4 className="text-lg font-semibold mb-3">Manifest Summary</h4>
                <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
                  <div>
                    <span className="text-gray-600 text-sm">Total Weight:</span>
                    <p className="font-medium">{manifestData?.manifest?.weight || '0'} kg</p>
                  </div>
                  <div>
                    <span className="text-gray-600 text-sm">Total Pieces:</span>
                    <p className="font-medium">{manifestData?.manifest?.pcs || '0'}</p>
                  </div>
                  <div>
                    <span className="text-gray-600 text-sm">Active Shipments:</span>
                    <p className="font-medium text-green-600">{manifestData?.shipment_counts?.active || '0'}</p>
                  </div>
                  <div>
                    <span className="text-gray-600 text-sm">Moved Shipments:</span>
                    <p className="font-medium text-yellow-600">{manifestData?.shipment_counts?.moved || '0'}</p>
                  </div>
                  <div>
                    <span className="text-gray-600 text-sm">Fleet:</span>
                    <p className="font-medium">{manifestData?.manifest?.fleet_name || 'N/A'}</p>
                  </div>
                </div>
              </div>
            )}
          </div>
          :
          ''
        }
      </div>

      {/* Create Manifest Modal */}
      <section>
        <Modal
          visible={addModal}
          width="80%"
          height="630"
          effect="fadeInUp"
          onClickAway={() => setAddModal(false)}
        >
          {loading ?
            <div className="flex flex-col mt-[30vh] mx-5">
              <div className="w-full bg-gray-200 rounded-full ">
                <div className="bg-[#E04343] text-xs font-medium text-white text-center p-0.5 leading-none rounded-full" style={{ width: `${percentage}%` }}> {percentage}%</div>
              </div>

              <div className='flex justify-center mt-4'>
                <Oval
                  visible={true}
                  height="60"
                  width="60"
                  color="#E04343"
                  secondaryColor="#FCBF94"
                  ariaLabel="oval-loading"
                  wrapperStyle={{}}
                  wrapperClass=""
                />
              </div>

              <div className='flex justify-center mt-3'>
                <span>Kindly wait!!!</span>
              </div>
            </div>
            :
            <div className=" " style={{ height: '100%', overflow: 'auto' }}>
              <div className="container bg-[#fff] rounded-lg p-2">
                <div className="px-3">
                  <span className="flex justify-between px-2 pt-3">
                    <p className='mt-2'>Create Runway Manifest</p>
                    <p className="cursor-pointer font-bold" onClick={(e) => setAddModal(false)}><SvgElement type={icontypesEnum.CANCEL} /></p>
                  </span>

                  <form onSubmit={handleSubmit}>
                    <div className="flex flex-col lg:flex-row lg:justify-between lg:max-w-screen-xl mx-auto mt-5">
                      <div className="relative flex flex-col min-w-0 break-words w-full">
                        <div className="flex-auto py-5 pt-0">
                          <div className="flex flex-wrap">
                            <div className="md:w-4/12 md:pr-4">
                              <div className="flex justify-between mb-3">
                                <label className="block text-sm font-semibold text-[#19213D]">Manifest Name</label>
                                <SvgElement type={icontypesEnum.QUESTIONMARK} />
                              </div>
                              <div className="relative mb-4">
                                <input required type="text" name='manifest_name' value={userData?.manifest_name} onChange={handleChange} className="border border-[#D1D1D1] text-gray-900 text-sm rounded-[5px] block w-full pl-6 p-2.5" placeholder="" />
                              </div>
                            </div>

                            <div className="md:w-8/12 w-full md:pr-4">
                              <div className="flex justify-between mb-3">
                                <label className="block text-sm font-semibold text-[#19213D]">Notes</label>
                                <SvgElement type={icontypesEnum.QUESTIONMARK} />
                              </div>
                              <div className="relative mb-4">
                                <input
                                  type="text"
                                  value={userData?.goods_description}
                                  name='goods_description'
                                  onChange={handleChange}
                                  className="border border-[#D1D1D1] text-gray-900 text-sm rounded-[5px] block w-full pl-6 p-2.5"
                                  placeholder=""
                                />
                              </div>
                            </div>

                            <div className="w-full md:w-3/12 md:pr-4">
                              <div className="relative w-full mb-5">
                                <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                  Select Status
                                </label>
                                <select required id="countries" name='shipment_status' onChange={handleChange} className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-r-[5px] block w-full p-2 placeholder:text-[#DADADA] placeholder:text-[12px] ease-linear transition-all duration-150">
                                  <option disabled selected>Select Status</option>
                                  <option value={'Out for Delivery'}>Out for Delivery</option>
                                </select>
                              </div>
                            </div>

                            <div className="w-full md:w-3/12 md:pr-4">
                              <div className="relative w-full mb-5">
                                <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                  Select Fleet
                                </label>
                                <select id="countries" onChange={(e: any) => { setShipmentRider(e); getAllRiders(e?.target?.value) }} className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-r-[5px] block w-full p-2 placeholder:text-[#DADADA] placeholder:text-[12px] ease-linear transition-all duration-150">
                                  <option selected>{'Select Fleet'}</option>
                                  <option selected value='all'>{'All free riders'}</option>
                                  {fleet?.map((datas: any, index: any) => (
                                    <option key={index} value={datas?.id}>{datas?.first_name}</option>
                                  ))}
                                </select>
                              </div>
                            </div>

                            <div className="w-full md:w-3/12 md:pr-4">
                              <div className="relative w-full mb-5">
                                <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                  Select Rider
                                </label>
                                <select id="countries" onChange={(e: any) => { setShipmentRider(e); getAllVehicles(e?.target?.value); updateDesc(e?.target?.value) }} className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-r-[5px] block w-full p-2 placeholder:text-[#DADADA] placeholder:text-[12px] ease-linear transition-all duration-150">
                                  <option selected>{'Select Rider'}</option>
                                  {riders?.map((datas: any, index: any) => (
                                    <option key={index} value={datas?.id}>{datas?.first_name}</option>
                                  ))}
                                </select>
                              </div>
                            </div>

                            <div className="w-full md:w-3/12 md:pr-4">
                              <div className="relative w-full mb-5">
                                <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                  Select Vehicle
                                </label>
                                <select id="countries" name='vehicle_name' onChange={handleChange} className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-r-[5px] block w-full p-2 placeholder:text-[#DADADA] placeholder:text-[12px] ease-linear transition-all duration-150">
                                  <option selected>{'Select Vehicle'}</option>
                                  {vehicle?.filter((data: any) => data?.status == 'Available')?.map((datas: any, index: any) => (
                                    <option key={index} value={datas?.vehicle_name}>{datas?.vehicle_name}</option>
                                  ))}
                                </select>
                              </div>
                            </div>


                            <div className="w-full md:w-4/12 md:pr-4">
                              <div className="relative w-full mb-5">
                                <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                  Event Date & Time <span className="text-gray-500 font-normal text-xs">(Optional)</span>
                                </label>
                                <input
                                  type="datetime-local"
                                  value={eventDateTime}
                                  onChange={(e) => setEventDateTime(e.target.value)}
                                  className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-2"
                                />
                                <p className="text-xs text-gray-500 mt-1">
                                  Defaults to current time. Adjust if backdating is needed.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="flex justify-end">
                      <button
                        type="button"
                        onClick={() => setShowShipment(!showShipment)}
                        style={{ borderRadius: '50px', color: '#F52424' }}
                        className="text-red-700 bg-red-200 focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm px-2 py-1.5 text-center"
                      >{showShipment ? "Hide" : 'Show'} Shipments</button>
                    </div>

                    <div className={showShipment ? "h-[250px] overflow-auto" : 'hidden'}>
                      <table className="w-full text-sm text-left rtl:text-right text-gray-500 border-separate border-spacing-y-3">
                        <thead className="text-[12px] text-[#808080] bg-[#FAFAFA]">
                          <tr>
                            <th scope="col" className="px-2 py-2">S/N</th>
                            <th scope="col" className="px-2 py-2">Receiver&nbsp;Name</th>
                            <th scope="col" className="px-2 py-2">Receiver&nbsp;Phone&nbsp;Number</th>
                            <th scope="col" className="px-2 py-2">Receiver&nbsp;Address</th>
                            <th scope="col" className="px-2 py-2">Status</th>
                            <th scope="col" className="px-2 py-2">Shipment&nbsp;Number</th>
                            <th scope="col" className="px-2 py-2">Fleet</th>
                            <th scope="col" className="px-2 py-2">Vehicle</th>
                          </tr>
                        </thead>
                        <tbody className=''>
                          {runmanifestListData?.filter((e: any) => e?.payment_status == 'successful')?.map(
                            (datas: any, index: any) => (
                              <tr className="bg-white" key={index}>
                                <td scope="row" className="px-6 py-4 font-medium text-[#6C757D] whitespace-nowrap">
                                  <div className="flex space-x-3">
                                    <div className="flex items-center">
                                      <input id="default-checkbox" type="checkbox" value={datas?.ShipmentNumber} onChange={selectShipment} className="w-4 h-4 accent-[#E04343] bg-gray-100 border-gray-300 rounded focus:ring-[#E04343] cursor-pointer" />
                                    </div>
                                  </div>
                                </td>
                                <td className="px-6 py-4">{datas?.ReceiverName}</td>
                                <td className="px-6 py-4">{datas?.ReceiverPhone}</td>
                                <td className="px-6 py-4">{datas?.ReceiverAdd1}</td>
                                <td className="px-2 py-2 cursor-pointer">
                                  {(datas?.Status == 'inReview' || datas?.Status == 'InReview') ?
                                    <p><b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#FFDDBD', color: '#F29339', borderRadius: '10px', padding: '2px 10px' }}>{datas?.Status}</b></p> :
                                    <p><b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#C9F0D0', color: '#51CF66', borderRadius: '10px', padding: '2px 10px' }}>{datas?.Status}</b></p>
                                  }
                                </td>
                                <td className="px-6 py-4">{datas?.ShipmentNumber ? datas?.ShipmentNumber : `Not Available`}</td>
                                <td className="px-6 py-4 cursor-pointer">{datas?.fleet_name ? datas?.fleet_name : "No Fleet"}</td>
                                <td className="px-6 py-4">{datas?.vehicle_name ? datas?.vehicle_name : "No Vehicle"}</td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>

                    <EnhancedRunwayBarcodeScanner />

                    <div className="flex justify-end pb-8">
                      <div className="mt-1">
                        <button type="submit" disabled={loading} className="text-white bg-[#E04343] rounded-[30px] transition ease-out delay-300 py-[10px] px-[42px] font-[700] text-[14px]">
                          <div className="flex justify-center gap-3">
                            <span>Create Run Manifest</span>
                            <Oval
                              visible={loading}
                              height="20"
                              width="20"
                              color="#E04343"
                              secondaryColor="#FCBF94"
                              ariaLabel="oval-loading"
                              wrapperStyle={{}}
                              wrapperClass=""
                            />
                          </div>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          }
        </Modal>
      </section>

      {/* Update Manifest Modal */}
      <section>
        <Modal
          visible={riderModal}
          width="900"
          height="400"
          effect="fadeInUp"
          onClickAway={() => setRiderModal(false)}
        >
          {loading ?
            <div className="flex justify-center mt-[20vh]">
              <Oval
                visible={true}
                height="80"
                width="80"
                color="#E04343"
                secondaryColor="#FCBF94"
                ariaLabel="oval-loading"
                wrapperStyle={{}}
                wrapperClass=""
              />
            </div>
            :
            <div className=" " style={{ height: '100%', overflow: 'auto' }}>
              <div className="container bg-[#fff] rounded-lg p-2">
                <div className="px-3">
                  <span className="flex justify-between px-2 pt-1">
                    <p className='mt-2'>Update Manifest</p>
                    <p className="cursor-pointer font-bold" onClick={(e) => setRiderModal(false)}><SvgElement type={icontypesEnum.CANCEL} /></p>
                  </span>
                  <form className="pb-4 rounded-lg" onSubmit={updateManifest}>
                    <div className="relative w-full mt-5 mb-4">
                      <label className="block mb-2 text-sm font-semibold text-[#19213D]">Manifest Name</label>
                      <input type="text" name='manifest_name' defaultValue={fleetData2?.manifest_name} onChange={handleChange2} className="border border-[#D1D1D1] text-gray-900 text-sm rounded-[5px] block w-full pl-6 p-2.5" />
                    </div>

                    <div className="relative w-full mb-4">
                      <label className="block mb-2 text-sm font-semibold text-[#19213D]">Notes</label>
                      <input
                        type="text"
                        name='Notes'
                        defaultValue={fleetData2?.Notes}
                        onChange={handleChange2}
                        className="border border-[#D1D1D1] text-gray-900 text-sm rounded-[5px] block w-full pl-6 p-2.5"
                      />
                    </div>

                    <div className="flex justify-end pb-3">
                      <div className="mt-1">
                        <button type="submit" disabled={loading} className="text-white bg-[#E04343] rounded-[30px] transition ease-out delay-300 py-[10px] px-[42px] font-[700] text-[14px]">
                          <div className="flex justify-center gap-3">
                            <span>Update Run Manifest</span>
                            <Oval
                              visible={loading}
                              height="20"
                              width="20"
                              color="#E04343"
                              secondaryColor="#FCBF94"
                              ariaLabel="oval-loading"
                              wrapperStyle={{}}
                              wrapperClass=""
                            />
                          </div>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          }
        </Modal>
      </section>

      {/* Status Update Modal */}
      <section>
        <Modal
          visible={statusModal}
          width="350"
          height="750"
          effect="fadeInUp"
          onClickAway={() => setStatusModal(false)}
        >
          <StatusUpdateModalContent
            shipmentId={shipmentId}
            userLoginData={userLoginData}
            statusOptions={statusOptions}
            canBypassCode={canBypassCode}
            manifestData={manifestData}
            onClose={() => {
              setStatusModal(false);
              setShipmentId([]);
            }}
            onSubmit={(data: any) => {
              // Your existing updateShipment logic here
              let eventCode = '';
              data.setLoading(true);

              STATUSTYPES?.filter((item: any) => item?.EventName == data.shipmentStatus)?.map((datas: any) => {
                eventCode = datas?.EventCode;
              });

              let shiData = shipmentId;
              let shipment = [
                {
                  "ThirdPartyToken": "null",
                  "SenderDetails": {
                    "SenderName": shiData?.SenderName || 'null',
                    "SenderCompanyName": shiData?.SenderCompanyName || "null",
                    "SenderCountryCode": shiData?.SenderCountryCode || "null",
                    "SenderAdd1": shiData?.SenderAdd1 || "null",
                    "SenderAdd2": shiData?.SenderAdd2 || 'null',
                    "SenderAdd3": shiData?.SenderAdd3 || 'null',
                    "SenderAddCity": shiData?.SenderAddCity || 'null',
                    "SenderAddState": shiData?.SenderAddState || 'null',
                    "SenderAddPostcode": shiData?.SenderAddPostcode || 'null',
                    "SenderPhone": shiData?.SenderPhone || 'null',
                    "SenderEmail": shiData?.SenderEmail || 'null',
                    "SenderFax": shiData?.SenderFax || 'null',
                    "SenderKycType": shiData?.SenderKycType || 'null',
                    "SenderKycNumber": shiData?.SenderKycNumber || 'null',
                    "SenderReceivingCountryTaxID": shiData?.SenderReceivingCountryTaxID || 'null'
                  },
                  "ReceiverDetails": {
                    "ReceiverName": shiData?.ReceiverName || 'null',
                    "ReceiverCompanyName": shiData?.ReceiverCompanyName || 'null',
                    "ReceiverCountryCode": shiData?.ReceiverCountryCode || 'null',
                    "ReceiverAdd1": shiData?.ReceiverAdd1 || 'null',
                    "ReceiverAdd2": shiData?.ReceiverAdd2 || 'null',
                    "ReceiverAdd3": shiData?.ReceiverAdd3 || 'null',
                    "ReceiverAddCity": shiData?.ReceiverAddCity || 'null',
                    "ReceiverAddState": shiData?.ReceiverAddState || 'null',
                    "ReceiverAddPostcode": shiData?.ReceiverAddPostcode || 'null',
                    "ReceiverMobile": shiData?.ReceiverMobile || 'null',
                    "ReceiverPhone": shiData?.ReceiverPhone || 'null',
                    "ReceiverEmail": shiData?.ReceiverEmail || 'null',
                    "ReceiverAddResidential": shiData?.ReceiverAddResidential || 'null',
                    "ReceiverFax": shiData?.ReceiverFax || 'null',
                    "ReceiverKycType": shiData?.ReceiverKycType || 'null',
                    "ReceiverKycNumber": shiData?.ReceiverKycNumber || 'null'
                  },
                  "PackageDetails": {
                    "GoodsDescription": shiData?.GoodsDescription || 'null',
                    "CustomValue": shiData?.CustomValue || 0,
                    "CustomCurrencyCode": shiData?.CustomCurrencyCode || 'null',
                    "InsuranceValue": shiData?.InsuranceValue || 0,
                    "InsuranceCurrencyCode": shiData?.InsuranceCurrencyCode || 'null',
                    "ShipmentTerm": shiData?.ShipmentTerm || 'null',
                    "GoodsOriginCountryCode": shiData?.GoodsOriginCountryCode || 'null',
                    "DeliveryInstructions": data.delieveryInstruction || 'null',
                    "Weight": shiData?.Weight || 0,
                    "WeightMeasurement": shiData?.WeightMeasurement || 'null',
                    "NoOfItems": shiData?.NoOfItems || 0,
                    "CubicL": shiData?.CubicL || 0,
                    "CubicW": shiData?.CubicW || 0,
                    "CubicH": shiData?.CubicH || 0,
                    "CubicWeight": shiData?.CubicWeight || 0,
                    "ServiceTypeName": shiData?.ServiceTypeName || 'null',
                    "BookPickUP": false,
                    "AlternateRef": shiData?.AlternateRef || 'null',
                    "SenderRef1": shiData?.SenderRef1 || 'null',
                    "SenderRef2": shiData?.SenderRef2 || 'null',
                    "SenderRef3": shiData?.SenderRef3 || 'null',
                    "DeliveryAgentCode": shiData?.DeliveryAgentCode || 'null',
                    "DeliveryRouteCode": shiData?.DeliveryRouteCode || 'null',
                    "BusinessType": shiData?.BusinessType || 'B2B',
                    "ShipmentResponseItem": [{
                      "ItemAlt": "null",
                      "ItemNoOfPcs": shiData?.NoOfItems || 'null',
                      "ItemCubicL": shiData?.CubicL || 'null',
                      "ItemCubicW": shiData?.CubicW || 'null',
                      "ItemCubicH": shiData?.CubicH || 'null',
                      "ItemWeight": shiData?.Weight || 'null',
                      "ItemCubicWeight": shiData?.CubicWeight || 'null',
                      "ItemDescription": shiData?.GoodsDescription || 'null',
                      "ItemCustomValue": shiData?.CustomValue || 'null',
                      "ItemCustomCurrencyCode": shiData?.CustomCurrencyCode || 'null',
                      "Notes": shiData?.Notes || 'null'
                    }],
                    "CODAmount": shiData?.CODAmount || 0,
                    "CODCurrencyCode": shiData?.CODCurrencyCode || 'null',
                    "Bag": shiData?.Bag || 0,
                    "Notes": shiData?.Notes || 'null',
                    "OriginLocCode": shiData?.OriginLocCode || 'null',
                    "BagNumber": shiData?.BagNumber || 'null',
                    "DeadWeight": shiData?.DeadWeight || 0,
                    "ReasonExport": shiData?.ReasonExport || 'null',
                    "DestTaxes": shiData?.DestTaxes || 0,
                    "Security": shiData?.Security || 0,
                    "Surcharge": shiData?.Surcharge || 0,
                    "ReceiverTaxID": shiData?.ReceiverTaxID || 'null',
                    "OrderNumber": shiData?.OrderNumber || 0,
                    "Incoterms": shiData?.Incoterms || 'null',
                    "ClearanceReference": shiData?.ClearanceReference || 'null'
                  }
                }
              ];

              const formData = new FormData();
              formData.append('Status', data.shipmentStatus || shipmentId?.status);
              formData.append('status_id', eventCode);
              formData.append('id', shipmentId?.id);
              formData.append('del_instruction', data.delieveryInstruction);
              formData.append('shiData', JSON.stringify(shipment));
              formData.append('delievery_code', canBypassCode ? 'bypass' : data.delieveryCode);
              formData.append('del_doc', data.img1);
              formData.append('updated_at', data.updatedAt);

              SuperAdminApis.updateShipmentStatusForDelivery(formData)
                .then((response: any) => {
                  if (response?.data?.status) {
                    toast.success(response?.data?.message);
                    setStatusModal(false);
                    data.setLoading(false);

                    const query: any = { search: '' };
                    SuperAdminApis.getSingleRunManifest(nextPageId, query).then(
                      (response: AxiosResponse<any>) => {
                        if (response?.data) {
                          setManifestData(response?.data?.data);
                        }
                      }
                    );
                  } else {
                    toast.warn(response?.data?.message);
                    setStatusModal(false);
                    data.setLoading(false);
                  }
                })
                .catch((err: any) => {
                  console.log(err);
                  data.setLoading(false);
                });
            }}
          />
        </Modal>
      </section>

      <ToastContainer
        position="top-right"
        autoClose={12000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover />
    </>
  )
}

export default RunwayManifest